(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("mobx-react"), require("ca-ui-toolkit"), require("mobx-state-tree"), require("underscore"), require("prop-types"), require("classnames"), require("mobx"), require("jquery"), require("react-dom"), require("polyglot"), require("explore-common"), require("gemini/lib/@waca/core-client/js/core-client/utils/BrowserUtils"), require("gemini/lib/@waca/core-client/js/core-client/utils/Deferred"), require("gemini/lib/@waca/dashboard-common/dist/glass/controllers/BaseSlideoutActionHandler"), require("gemini/pinning/PinsPanel"), require("gemini/pinning/PinView"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "mobx-react", "ca-ui-toolkit", "mobx-state-tree", "underscore", "prop-types", "classnames", "mobx", "jquery", "react-dom", "polyglot", "explore-common", "gemini/lib/@waca/core-client/js/core-client/utils/BrowserUtils", "gemini/lib/@waca/core-client/js/core-client/utils/Deferred", "gemini/lib/@waca/dashboard-common/dist/glass/controllers/BaseSlideoutActionHandler", "gemini/pinning/PinsPanel", "gemini/pinning/PinView"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("react"), require("mobx-react"), require("ca-ui-toolkit"), require("mobx-state-tree"), require("underscore"), require("prop-types"), require("classnames"), require("mobx"), require("jquery"), require("react-dom"), require("polyglot"), require("explore-common"), require("gemini/lib/@waca/core-client/js/core-client/utils/BrowserUtils"), require("gemini/lib/@waca/core-client/js/core-client/utils/Deferred"), require("gemini/lib/@waca/dashboard-common/dist/glass/controllers/BaseSlideoutActionHandler"), require("gemini/pinning/PinsPanel"), require("gemini/pinning/PinView")) : factory(root["react"], root["mobx-react"], root["ca-ui-toolkit"], root["mobx-state-tree"], root["underscore"], root["prop-types"], root["classnames"], root["mobx"], root["jquery"], root["react-dom"], root["polyglot"], root["explore-common"], root["gemini/lib/@waca/core-client/js/core-client/utils/BrowserUtils"], root["gemini/lib/@waca/core-client/js/core-client/utils/Deferred"], root["gemini/lib/@waca/dashboard-common/dist/glass/controllers/BaseSlideoutActionHandler"], root["gemini/pinning/PinsPanel"], root["gemini/pinning/PinView"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_5__, __WEBPACK_EXTERNAL_MODULE_6__, __WEBPACK_EXTERNAL_MODULE_7__, __WEBPACK_EXTERNAL_MODULE_8__, __WEBPACK_EXTERNAL_MODULE_9__, __WEBPACK_EXTERNAL_MODULE_10__, __WEBPACK_EXTERNAL_MODULE_11__, __WEBPACK_EXTERNAL_MODULE_14__, __WEBPACK_EXTERNAL_MODULE_17__, __WEBPACK_EXTERNAL_MODULE_22__, __WEBPACK_EXTERNAL_MODULE_33__, __WEBPACK_EXTERNAL_MODULE_150__, __WEBPACK_EXTERNAL_MODULE_163__, __WEBPACK_EXTERNAL_MODULE_165__, __WEBPACK_EXTERNAL_MODULE_168__, __WEBPACK_EXTERNAL_MODULE_169__) {
return webpackJsonp([2],[
/* 0 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_5__;

/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_6__;

/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_7__;

/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_8__;

/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_9__;

/***/ }),
/* 10 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_10__;

/***/ }),
/* 11 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_11__;

/***/ }),
/* 12 */,
/* 13 */,
/* 14 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_14__;

/***/ }),
/* 15 */,
/* 16 */,
/* 17 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_17__;

/***/ }),
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_22__;

/***/ }),
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_33__;

/***/ }),
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(10);

var _classnames2 = _interopRequireDefault(_classnames);

var _caUiToolkit = __webpack_require__(6);

var _favorite_ = __webpack_require__(127);

var _favorite_2 = _interopRequireDefault(_favorite_);

var _favorite_3 = __webpack_require__(128);

var _favorite_4 = _interopRequireDefault(_favorite_3);

var _overflowMenuHorizontal_ = __webpack_require__(129);

var _overflowMenuHorizontal_2 = _interopRequireDefault(_overflowMenuHorizontal_);

var _ContextMenuIcon = __webpack_require__(62);

var _ContextMenuIcon2 = _interopRequireDefault(_ContextMenuIcon);

__webpack_require__(133);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| IBM Cognos Products: Explore
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| (C) Copyright IBM Corp. 2018
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *|
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var FEATURES = {
	FAVOURITE: false
};

var Card = function (_Component) {
	_inherits(Card, _Component);

	function Card(props) {
		_classCallCheck(this, Card);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_this.el = null;
		return _this;
	}

	Card.prototype.componentDidMount = function componentDidMount() {
		this.props.cacheNodeRef && this.props.cacheNodeRef(this.props.id, this.el);
	};

	Card.prototype.componentWillUnmount = function componentWillUnmount() {
		this.props.cacheNodeRef && this.props.cacheNodeRef(this.props.id, null);
	};

	Card.prototype.render = function render() {
		var _this2 = this;

		var _props = this.props,
		    view = _props.view,
		    title = _props.title,
		    tabIndex = _props.tabIndex,
		    onClick = _props.onClick,
		    isSelected = _props.isSelected,
		    isHidden = _props.isHidden;


		var footer = this.renderFooter();

		var classes = (0, _classnames2.default)({
			card: true,
			selected: isSelected,
			'is-hidden': isHidden
		});

		return _react2.default.createElement(
			'div',
			{
				className: classes,
				tabIndex: tabIndex,
				onClick: onClick,
				onContextMenu: function onContextMenu(event) {
					return _this2.onContextMenu(event);
				},
				ref: function ref(node) {
					return _this2.el = node;
				}
			},
			!isHidden && title && _react2.default.createElement(_caUiToolkit.Label, { label: title, ellipsis: true }),
			_react2.default.createElement(
				'div',
				{
					className: 'card-view'
				},
				view
			),
			footer
		);
	};

	Card.prototype.renderFooter = function renderFooter() {
		if (!this.props.hasFooter) {
			return;
		}

		var favouriteIcon = this.renderFavouriteIcon();
		var contextMenu = this.renderContextMenu();

		return _react2.default.createElement(
			'div',
			{ className: 'card-footer' },
			favouriteIcon,
			contextMenu
		);
	};

	Card.prototype.renderContextMenu = function renderContextMenu() {
		var _this3 = this;

		var _props2 = this.props,
		    contextMenuItems = _props2.contextMenuItems,
		    onContextMenuChange = _props2.onContextMenuChange,
		    onContextMenuToggle = _props2.onContextMenuToggle;


		return _react2.default.createElement(
			'div',
			{ className: 'card-footer-contextMenu' },
			_react2.default.createElement(_ContextMenuIcon2.default, {
				iconId: _overflowMenuHorizontal_2.default.id,
				items: contextMenuItems,
				onChange: function onChange(event) {
					return onContextMenuChange(event, _this3.props.id);
				},
				onToggle: function onToggle() {
					return onContextMenuToggle(!contextMenuItems);
				}
			})
		);
	};

	Card.prototype.renderFavouriteIcon = function renderFavouriteIcon() {
		if (!FEATURES.FAVOURITE) {
			return _react2.default.createElement('div', { className: 'favourite' });
		}

		var _props3 = this.props,
		    isFavourite = _props3.isFavourite,
		    onToggleFavourite = _props3.onToggleFavourite;


		var classes = (0, _classnames2.default)({
			favourite: true,
			on: isFavourite,
			off: !isFavourite
		});

		return _react2.default.createElement(
			'div',
			{ className: classes, onClick: function onClick() {
					return onToggleFavourite();
				} },
			_react2.default.createElement(_caUiToolkit.SVGIcon, { className: 'on', iconId: _favorite_2.default.id }),
			_react2.default.createElement(_caUiToolkit.SVGIcon, { className: 'off', iconId: _favorite_4.default.id })
		);
	};

	Card.prototype.onContextMenu = function onContextMenu(event) {
		var _props4 = this.props,
		    contextMenuItems = _props4.contextMenuItems,
		    onContextMenuToggle = _props4.onContextMenuToggle;


		onContextMenuToggle && onContextMenuToggle(!contextMenuItems);
		event.preventDefault();
	};

	return Card;
}(_react.Component);

Card.propTypes = {
	id: _propTypes2.default.string.isRequired,
	title: _propTypes2.default.string,
	view: _propTypes2.default.element,
	hasFooter: _propTypes2.default.bool,
	onClick: _propTypes2.default.func,
	onContextMenuChange: _propTypes2.default.func,
	onContextMenuToggle: _propTypes2.default.func,
	onToggleFavourite: _propTypes2.default.func,
	isSelected: _propTypes2.default.bool,
	isFavourite: _propTypes2.default.bool,
	isHidden: _propTypes2.default.bool,
	contextMenuItems: _propTypes2.default.array,
	tabIndex: _propTypes2.default.string,
	cacheNodeRef: _propTypes2.default.func
};

Card.defaultProps = {
	hasFooter: true,
	onClick: function onClick() {},
	onToggleFavourite: function onToggleFavourite() {},
	onContextMenuChange: function onContextMenuChange() {},
	onContextMenuToggle: function onContextMenuToggle() {},
	isSelected: false,
	isFavourite: false,
	isVisible: true,
	contextMenuItems: null
};

exports.default = Card;

/***/ }),
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _class; /*
             *+------------------------------------------------------------------------+
             *| Licensed Materials - Property of IBM
             *| IBM Cognos Products: Explore
             *| (C) Copyright IBM Corp. 2018
             *|
             *| US Government Users Restricted Rights - Use, duplication or disclosure
             *| restricted by GSA ADP Schedule Contract with IBM Corp.
             *+------------------------------------------------------------------------+
             */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(5);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _caUiToolkit = __webpack_require__(6);

__webpack_require__(130);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ContextMenuIcon = (0, _mobxReact.observer)(_class = function (_Component) {
	_inherits(ContextMenuIcon, _Component);

	function ContextMenuIcon(props) {
		_classCallCheck(this, ContextMenuIcon);

		return _possibleConstructorReturn(this, _Component.call(this, props));
	}

	ContextMenuIcon.prototype.render = function render() {
		var _this2 = this;

		var iconId = this.props.iconId;


		return _react2.default.createElement(
			'div',
			{
				className: 'explore__contextMenu-anchor',
				onClick: function onClick(event) {
					return _this2.handleClick(event);
				},
				onTouchEnd: function onTouchEnd(event) {
					return _this2.handleClick(event);
				}
			},
			_react2.default.createElement(_caUiToolkit.SVGIcon, {
				className: 'context-menu',
				iconId: iconId
			}),
			this.renderContextMenu()
		);
	};

	ContextMenuIcon.prototype.renderContextMenu = function renderContextMenu() {
		var _props = this.props,
		    _props$placement = _props.placement,
		    placement = _props$placement === undefined ? 'right' : _props$placement,
		    items = _props.items,
		    children = _props.children;


		if (!items || !items.length) {
			return;
		}

		return _react2.default.createElement(
			_caUiToolkit.ContextMenu,
			{
				theme: true,
				placement: placement,
				domNodeToAttachTo: document.body,
				onClose: this.onClose.bind(this),
				onChange: this.onChange.bind(this)
			},
			this.renderItems(items),
			children
		);
	};

	ContextMenuIcon.prototype.renderItems = function renderItems(items) {
		var _this3 = this;

		if (items) {
			return items.map(function (section, index) {
				return _this3.renderSection(section, index);
			});
		}
	};

	ContextMenuIcon.prototype.renderSection = function renderSection(section, key) {
		if (Array.isArray(section.items)) {
			var _section$name = section.name,
			    name = _section$name === undefined ? 'menu' : _section$name,
			    label = section.label,
			    items = section.items;


			return _react2.default.createElement(_caUiToolkit.ContextMenu.List, { key: key, content: items, name: name, label: label, clickSelection: true });
		} else {
			return _react2.default.createElement(_caUiToolkit.ContextMenu.Separator, { key: key });
		}
	};

	ContextMenuIcon.prototype.onChange = function onChange(name, value) {
		var event = {};
		event[name] = value;

		this.props.onChange(event);
	};

	ContextMenuIcon.prototype.handleClick = function handleClick(event) {
		this.onToggle();
		// Prevents the mouse up event when touch event happens
		event.preventDefault();
	};

	ContextMenuIcon.prototype.onToggle = function onToggle() {
		var toggle = !(this.props.items && this.props.items.length);

		this.props.onToggle(toggle);
	};

	ContextMenuIcon.prototype.onClose = function onClose() {
		this.props.onToggle(false);
	};

	return ContextMenuIcon;
}(_react.Component)) || _class;

ContextMenuIcon.propTypes = {
	iconId: _propTypes2.default.string.isRequired,
	items: _propTypes2.default.array,
	children: _propTypes2.default.any,
	placement: _propTypes2.default.string,
	onChange: _propTypes2.default.func,
	onToggle: _propTypes2.default.func
};

ContextMenuIcon.defaultProps = {
	items: [],
	onChange: function onChange() {},
	onToggle: function onToggle() {}
};

exports.default = ContextMenuIcon;

/***/ }),
/* 63 */,
/* 64 */,
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| IBM Cognos Products: Explore
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| (C) Copyright IBM Corp. 2018
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *|
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var CardView = function (_Component) {
	_inherits(CardView, _Component);

	function CardView() {
		_classCallCheck(this, CardView);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	CardView.prototype.render = function render() {
		return _react2.default.createElement('div', {
			className: 'cardThumbnails__item',
			dangerouslySetInnerHTML: {
				__html: this.props.thumbnail.data
			}
		});
	};

	return CardView;
}(_react.Component);

CardView.propTypes = {
	thumbnail: _propTypes2.default.shape({
		data: _propTypes2.default.string
	})
};

exports.default = CardView;

/***/ }),
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(32);
module.exports = __webpack_require__(121);


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.PinView = exports.CardGridSlideout = exports.CardGridExtension = undefined;

var _CardGridExtension = __webpack_require__(122);

var _CardGridExtension2 = _interopRequireDefault(_CardGridExtension);

var _CardGridSlideoutActionHandler = __webpack_require__(164);

var _CardGridSlideoutActionHandler2 = _interopRequireDefault(_CardGridSlideoutActionHandler);

var _PinView = __webpack_require__(166);

var _PinView2 = _interopRequireDefault(_PinView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.CardGridExtension = _CardGridExtension2.default;
exports.CardGridSlideout = _CardGridSlideoutActionHandler2.default;
exports.PinView = _PinView2.default; /*
                                      *+------------------------------------------------------------------------+
                                      *| Licensed Materials - Property of IBM
                                      *| IBM Cognos Products: Explore
                                      *| (C) Copyright IBM Corp. 2018
                                      *|
                                      *| US Government Users Restricted Rights - Use, duplication or disclosure
                                      *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                      *+------------------------------------------------------------------------+
                                      */

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(17);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _APIStore = __webpack_require__(123);

var _APIStore2 = _interopRequireDefault(_APIStore);

var _SidePane = __webpack_require__(124);

var _SidePane2 = _interopRequireDefault(_SidePane);

var _CardListViewModel = __webpack_require__(155);

var _CardListViewModel2 = _interopRequireDefault(_CardListViewModel);

var _Loading = __webpack_require__(67);

var _Loading2 = _interopRequireDefault(_Loading);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

__webpack_require__(161);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018, 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
var $ = __webpack_require__(14);

var Deferred = __webpack_require__(163);
var IDLE_TIMEOUT = 2000;

var CardGridExtension = function () {
	function CardGridExtension(options) {
		_classCallCheck(this, CardGridExtension);

		this.glassContext = options.glassContext;
		this.$el = $('<div class="explore-thumbnail-container"></div>');

		this.cardListVM = null;

		this.thumbnailStore = null;
		this.thumbnails = null;
		this._eventDisposeFns = [];

		this.initialize();
	}

	CardGridExtension.prototype._getExploreView = function _getExploreView() {
		return this.glassContext.appController.getCurrentContentView();
	};

	//TODO - APIs: ************ Start Dependencies on boardModel
	//Eventing 'widget:change', 'addWidget', 'addLayouts', 'addFragment'


	CardGridExtension.prototype._addCanvasListener = function _addCanvasListener(eventName, callback) {
		return this.boardModel && this.boardModel.on(eventName, callback);
	};

	//WidgetInstances (widgetModels) are currently needed by the thumbnail service.
	//Could we just use ID's and push knowledge of the widgetModels down to the thumbnail service?


	CardGridExtension.prototype._getWidgetModel = function _getWidgetModel(widgetId) {
		return this.boardModel && this.boardModel.widgetInstances[widgetId];
	};

	CardGridExtension.prototype._getWidgetModels = function _getWidgetModels() {
		return this.boardModel && this.boardModel.widgetInstances ? Object.keys(this.boardModel.widgetInstances) : [];
	};
	//TODO - APIs: ************ End Dependencies on boardModel

	CardGridExtension.prototype.getServiceRegistry = function getServiceRegistry() {
		var contentView = this._getExploreView();
		if (contentView) {
			return contentView.services;
		} else {
			throw new Error('Content view did not load.');
		}
	};

	CardGridExtension.prototype.initialize = function initialize() {
		var _this = this;

		this.readyDfd = new Deferred();
		this.services = this.getServiceRegistry();
		this.logger = this.glassContext.getCoreSvc('.Logger');

		return Promise.all([this.services.getSvc('.Thumbnail'), this.services.getSvc('.DndManager')]).then(function (_ref) {
			var ThumbnailSvc = _ref[0],
			    dndManager = _ref[1];

			//Get the exploreView.
			var exploreView = _this._getExploreView();
			var exploreVM = exploreView.getExploreVM();
			_this.boardModel = exploreView.boardModel; //TODO: Will be removed soon!
			_this.dndManager = dndManager;

			_this.thumbnailService = ThumbnailSvc;
			_this.thumbnailStore = _this.thumbnailService.getStoreAPI({
				defaultFn: function defaultFn(type) {
					if (!type) {
						return Promise.resolve('');
					}
					var visDefinitions = exploreVM.getDashboardApi().getFeature('VisDefinitions');
					var def = visDefinitions.getById(type);
					var altThumbnailImage = _StringResources2.default.get('thumbnail_alt_default_img', { vistype: def.getLabel() });
					return Promise.resolve('<img class="cardThumbnails__item--default" alt="' + altThumbnailImage + '" src="' + def.getPlaceholderIconUri() + '" />');
				}
			});

			// as a prototype of the feature, when a new card list view is
			// opened, always clear the active state
			exploreVM.notification.setListVisibility(true);
			exploreVM.notification.setActive(false);

			_this.cardListVM = _CardListViewModel2.default.create({
				thumbnails: {}
			}, {
				cardActions: exploreVM.cardActions,
				getThumbnails: function getThumbnails(widget) {
					var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { idle: true };
					return _this.getThumbnails(widget, options);
				}
			});
			_this.cardListVM.setSelectionModel(exploreVM.selectedCards);
			_this.cardListVM.setLayoutModel(exploreView.getExploreContainerLayoutModel());
			_APIStore2.default.then(function (apis) {
				return apis.set('cardList', _this.cardListVM);
			});

			var _thumbnailStore$on = _this.thumbnailStore.on('all', function (_ref2) {
				var id = _ref2.id;

				_this.cardListVM.syncThumbnails(id);
			}),
			    thumbnailStoreRemoveListener = _thumbnailStore$on.remove;

			_this._eventDisposeFns.push(thumbnailStoreRemoveListener);

			var _addCanvasListener2 = _this._addCanvasListener('widget:change', function (_ref3) {
				var name = _ref3.name,
				    model = _ref3.model;

				if (name === 'visId') {
					var widgetId = model ? model.id : undefined;
					_this.cardListVM.syncThumbnails(widgetId);
				}
			}),
			    widgetChangeRemoveListener = _addCanvasListener2.remove;

			_this._eventDisposeFns.push(widgetChangeRemoveListener);

			// We need a re-sync thumbnail for the use cases when we add related or recommended visualizations

			var _addCanvasListener3 = _this._addCanvasListener('addWidget', function (payload) {
				var widgetId = payload.value.parameter.model.id;
				if (widgetId) {
					_this.cardListVM.syncThumbnails(widgetId);
				}
			}),
			    canvasWidgetAddRemoveListener = _addCanvasListener3.remove;

			_this._eventDisposeFns.push(canvasWidgetAddRemoveListener);

			// TODO: figure out if we still need this

			var _addCanvasListener4 = _this._addCanvasListener('addLayouts', function (payload) {
				var addLayoutArray = payload.value.parameter.addLayoutArray;
				var widgetIds = [];
				var addToWidgetIds = function addToWidgetIds(widget) {
					widgetIds.push(widget.id);
				};
				addLayoutArray.forEach(function (addedLayout) {
					if (addedLayout.model.items) {
						var widgets = addedLayout.model.items;
						widgets.forEach(addToWidgetIds);
					}
				});
				_this.cardListVM.syncThumbnails(widgetIds.length > 0 ? widgetIds : undefined);
			}),
			    canvasLayoutAddRemoveListener = _addCanvasListener4.remove;

			_this._eventDisposeFns.push(canvasLayoutAddRemoveListener);

			var _addCanvasListener5 = _this._addCanvasListener('addFragment', function (payload) {
				var widgets = payload.value.parameter.model.widgets;
				var widgetIds = widgets.map(function (widget) {
					return widget.id;
				});
				_this.cardListVM.syncThumbnails(widgetIds.length > 0 ? widgetIds : undefined);
			}),
			    canvasFragmentAddRemoveListener = _addCanvasListener5.remove;

			_this._eventDisposeFns.push(canvasFragmentAddRemoveListener);

			_this.cardListVM.syncInitialThumbnails().then(function () {
				if (_this.readyDfd) {
					_this.readyDfd.resolve();
				}
			});
		});
	};

	CardGridExtension.prototype.getThumbnail = function getThumbnail(widget) {
		var _this2 = this;

		var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { idle: true };

		var widgetInstance = typeof widget === 'string' ? this._getWidgetModel(widget) : widget;
		if (!widgetInstance) {
			return Promise.resolve();
		}

		var idleAsyncWrapper = function idleAsyncWrapper(fn) {
			return new Promise(function (resolve, reject) {
				window.requestIdleCallback(function () {
					try {
						var result = fn();
						if (result.then) {
							result = result.then(resolve).catch(reject);
						} else {
							resolve(result);
						}
					} catch (error) {
						reject(error);
					}
				}, { timeout: IDLE_TIMEOUT /* Force the callback to be executed after timeout to prevent too long idling period */ });
			});
		};
		var _get = function _get() {
			return _this2.thumbnailService.get(widgetInstance, widgetInstance.visId, _this2.thumbnailStore).then(function (thumbnail) {

				var widgetId = widgetInstance.id;
				var type = widgetInstance.visId;
				var data = void 0;
				var error = void 0;
				var warning = void 0;
				if ((typeof thumbnail === 'undefined' ? 'undefined' : _typeof(thumbnail)) === 'object') {
					data = thumbnail.data;
					error = thumbnail.error;
					warning = thumbnail.warning;
				} else {
					data = thumbnail;
				}

				return _this2._processThumbnailData({ widgetId: widgetId, type: type, data: data, error: error, warning: warning });
			}).catch(function (error) {
				_this2.logger.error('Error occurred while retrieving thumbnails from the thumbnail store. [' + widget.id + ']', error);
				throw error;
			});
		};

		if (options.idle) {
			return idleAsyncWrapper(function () {
				return _get();
			});
		}

		return _get();
	};

	CardGridExtension.prototype._processThumbnailData = function _processThumbnailData(thumbnail) {
		if (!thumbnail.data && this.thumbnailStore) {
			return this.thumbnailStore.getVisTypeDefault(thumbnail.type).then(function (data) {
				return _extends({}, thumbnail, { data: data });
			});
		}
		return Promise.resolve(thumbnail);
	};

	CardGridExtension.prototype.getThumbnails = function getThumbnails(widgets) {
		var _this3 = this;

		var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { idle: true };


		var widgetInstances = void 0;
		if (widgets) {
			var widgetArray = Array.isArray(widgets) ? widgets : [widgets];
			if (typeof widgetArray[0] === 'string') {
				widgetInstances = widgetArray.map(function (widgetId) {
					return _this3._getWidgetModel(widgetId);
				});
			} else {
				widgetInstances = widgetArray;
			}
		} else {
			widgetInstances = this._getWidgetModels().map(function (widgetId) {
				return _this3._getWidgetModel(widgetId);
			});
		}

		var thumbnails = [];
		var promise = Promise.resolve();
		widgetInstances.forEach(function (widgetInstance) {
			promise = promise.then(function () {
				return _this3.getThumbnail(widgetInstance, options).then(function (thumbnail) {
					if (thumbnail) {
						thumbnails.push(thumbnail);
					}
				});
			});
		});
		return promise.then(function () {
			return thumbnails;
		});
	};

	CardGridExtension.prototype.renderDOM = function renderDOM(component) {
		_reactDom2.default.render(component, this.$el.get(0));
	};

	CardGridExtension.prototype.unmountDOM = function unmountDOM(node) {
		_reactDom2.default.unmountComponentAtNode(node);
	};

	CardGridExtension.prototype.render = function render() {
		var _this4 = this;

		this.renderDOM(_react2.default.createElement(_Loading2.default, { size: 'normal' }));
		return this.readyDfd.promise.then(function () {
			return _this4.renderDOM(_react2.default.createElement(_SidePane2.default, {
				cardListVM: _this4.cardListVM,
				dndManager: _this4.dndManager
			}));
		});
	};

	CardGridExtension.prototype.remove = function remove() {
		this.cardListVM.resetCardNotification();
		this._eventDisposeFns.forEach(function (fn) {
			return fn();
		});
		this._eventDisposeFns = [];
		this.unmountDOM(this.$el.get(0));
		this.$el.remove();
		this.$el = null;
		this.readyDfd = null;
		this.glassContext = null;
		this.thumbnailStore = null;
		this.thumbnails = null;
		this.cardListVM = null;
		_APIStore2.default.then(function (apis) {
			return apis.remove('cardList');
		});
	};

	return CardGridExtension;
}();

exports.default = CardGridExtension;

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018, 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

var APIStore = function () {
	function APIStore() {
		_classCallCheck(this, APIStore);

		this.apis = {};
	}

	APIStore.prototype.set = function set(key, api) {
		this.apis[key] = api;
	};

	APIStore.prototype.remove = function remove(key) {
		delete this.apis[key];
	};

	return APIStore;
}();

exports.default = new Promise(function (resolve) {
	var apiStore = new APIStore();
	window.exploreApis = {
		get: function get(key) {
			return apiStore.apis[key];
		}
	};
	resolve(apiStore);
});

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _class; /*
             *+------------------------------------------------------------------------+
             *| Licensed Materials - Property of IBM
             *| IBM Cognos Products: Explore
             *| (C) Copyright IBM Corp. 2018, 2019
             *|
             *| US Government Users Restricted Rights - Use, duplication or disclosure
             *| restricted by GSA ADP Schedule Contract with IBM Corp.
             *+------------------------------------------------------------------------+
             */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(5);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _underscore = __webpack_require__(8);

var _underscore2 = _interopRequireDefault(_underscore);

var _SidePaneContent = __webpack_require__(125);

var _SidePaneContent2 = _interopRequireDefault(_SidePaneContent);

var _SidePaneHeader = __webpack_require__(151);

var _SidePaneHeader2 = _interopRequireDefault(_SidePaneHeader);

__webpack_require__(153);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SidePane = (0, _mobxReact.observer)(_class = function (_Component) {
	_inherits(SidePane, _Component);

	function SidePane() {
		var _temp, _this, _ret;

		_classCallCheck(this, SidePane);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.onContextMenuChange = function (_ref, cardId) {
			var menu = _ref.menu;
			var cardListVM = _this.props.cardListVM;


			var card = _this._getCard(cardId);
			cardListVM.clearContextMenu();
			_this.props.cardListVM.performAction(menu, card && [card]);
			//This is needed because after the action takes place, the focus is then set onto glass.
			//TODO: This could be improved if the focus isn't be automatically set by glass, and let each component decide.
			_underscore2.default.defer(function () {
				var exploreVM = cardListVM.exploreVM;

				exploreVM.setFocusOnExploreContainer();
			});
		}, _this.onDelete = function () {
			var result = _this.props.cardListVM.performAction('deleteCard');
			//This is needed because after the action takes place, the focus is then set onto glass.
			//TODO: This could be improved if the focus isn't be automatically set by glass, and let each component decide.
			_underscore2.default.defer(function () {
				var exploreVM = _this.props.cardListVM.exploreVM;

				exploreVM.setFocusOnExploreContainer();
			});
			return result;
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	SidePane.prototype.render = function render() {
		var _props = this.props,
		    cardListVM = _props.cardListVM,
		    dndManager = _props.dndManager;


		return _react2.default.createElement(
			'div',
			{ className: 'sidePane' },
			_react2.default.createElement(_SidePaneHeader2.default, {
				cardListVM: cardListVM,
				onContextMenuChange: this.onContextMenuChange
			}),
			_react2.default.createElement(_SidePaneContent2.default, {
				cardListVM: cardListVM,
				dndManager: dndManager,
				onContextMenuChange: this.onContextMenuChange,
				onDelete: this.onDelete
			})
		);
	};

	// Events

	SidePane.prototype._getCard = function _getCard(id) {
		var exploreContainerLayoutModel = this.props.cardListVM.layoutModel;

		return exploreContainerLayoutModel && exploreContainerLayoutModel.findModel(id);
	};

	return SidePane;
}(_react.Component)) || _class;

SidePane.propTypes = {
	cardListVM: _propTypes2.default.object.isRequired,
	dndManager: _propTypes2.default.object.isRequired
};

SidePane.defaultProps = {};

exports.default = SidePane;

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _class; /*
             *+------------------------------------------------------------------------+
             *| Licensed Materials - Property of IBM
             *| IBM Cognos Products: Explore
             *| (C) Copyright IBM Corp. 2018
             *|
             *| US Government Users Restricted Rights - Use, duplication or disclosure
             *| restricted by GSA ADP Schedule Contract with IBM Corp.
             *+------------------------------------------------------------------------+
             */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(5);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _cards = __webpack_require__(126);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SidePaneContent = (0, _mobxReact.observer)(_class = function (_Component) {
	_inherits(SidePaneContent, _Component);

	function SidePaneContent() {
		var _temp, _this, _ret;

		_classCallCheck(this, SidePaneContent);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.onContextMenuToggle = function (cardId, toggle) {
			var cardListVM = _this.props.cardListVM;

			if (toggle) {
				cardListVM.showContextMenu([cardId]);
			} else {
				cardListVM.clearContextMenu();
			}
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	SidePaneContent.prototype.render = function render() {
		var _props = this.props,
		    cardListVM = _props.cardListVM,
		    dndManager = _props.dndManager;


		return _react2.default.createElement(
			'div',
			{ className: 'sidePane__content' },
			_react2.default.createElement(_cards.CardList, {
				handlers: {
					getContextMenuItems: cardListVM.getContextMenuItems
				},
				cardListVM: cardListVM,
				cardActions: cardListVM.exploreVM.cardActions,
				onContextMenuToggle: this.onContextMenuToggle,
				onContextMenuChange: this.props.onContextMenuChange,
				onDelete: this.props.onDelete,
				dndManager: dndManager
			})
		);
	};

	// Events

	return SidePaneContent;
}(_react.Component)) || _class;

SidePaneContent.propTypes = {
	cardListVM: _propTypes2.default.object.isRequired,
	dndManager: _propTypes2.default.object.isRequired,
	onContextMenuChange: _propTypes2.default.func,
	onDelete: _propTypes2.default.func
};

SidePaneContent.defaultProps = {
	onContextMenuChange: function onContextMenuChange() {},
	onDelete: function onDelete() {}
};

exports.default = SidePaneContent;

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.CardList = exports.Card = undefined;

var _Card = __webpack_require__(41);

var _Card2 = _interopRequireDefault(_Card);

var _CardList = __webpack_require__(135);

var _CardList2 = _interopRequireDefault(_CardList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
exports.Card = _Card2.default;
exports.CardList = _CardList2.default;

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "favorite_16",
  "use": "favorite_16-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"favorite_16\"><path d=\"M11.2 3c.7 0 1.4.3 2 .8 1.1 1.1 1.1 2.9 0 4L8 13.1 2.8 7.8c-1.1-1.1-1.1-2.9 0-4s2.8-1.1 3.9 0L8 5.1l1.3-1.3c.5-.5 1.2-.8 1.9-.8m0-1c-1 0-2 .4-2.7 1.1l-.5.6-.6-.6C6 1.6 3.6 1.6 2.1 3.1S.6 7 2.1 8.5l5.9 6 5.9-6c1.5-1.5 1.5-3.9 0-5.4-.7-.7-1.7-1.1-2.7-1.1z\" /><path style=\"fill:none\" d=\"M0 0h16v16H0z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "favorite_32",
  "use": "favorite_32-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"favorite_32\"><path d=\"M22.45 6a5.47 5.47 0 013.91 1.64 5.7 5.7 0 010 8L16 26.13 5.64 15.64a5.7 5.7 0 010-8 5.48 5.48 0 017.82 0l2.54 2.6 2.53-2.58A5.44 5.44 0 0122.45 6m0-2a7.47 7.47 0 00-5.34 2.24L16 7.36l-1.11-1.12a7.49 7.49 0 00-10.68 0 7.72 7.72 0 000 10.82L16 29l11.79-11.94a7.72 7.72 0 000-10.82A7.49 7.49 0 0022.45 4z\" /><path style=\"fill:none\" d=\"M0 0h32v32H0z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "overflow-menu--horizontal_16",
  "use": "overflow-menu--horizontal_16-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"overflow-menu--horizontal_16\"><circle cx=\"3\" cy=\"8\" r=\"1\" /><circle cx=\"8\" cy=\"8\" r=\"1\" /><circle cx=\"13\" cy=\"8\" r=\"1\" /><path style=\"fill:none\" d=\"M0 0h16v16H0z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(131);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/resolve-url-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./ContextMenuIcon.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/resolve-url-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./ContextMenuIcon.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/*\n *+------------------------------------------------------------------------+\n *| Licensed Materials - Property of IBM\n *| IBM Cognos Products: Explore\n *| (C) Copyright IBM Corp. 2018\n *|\n *| US Government Users Restricted Rights - Use, duplication or disclosure\n *| restricted by GSA ADP Schedule Contract with IBM Corp.\n *+------------------------------------------------------------------------+\n */\n\n.explore__contextMenu-anchor {\n  cursor: pointer;\n  width: 24px;\n  height: 24px;\n}\n\n", ""]);

// exports


/***/ }),
/* 132 */,
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(134);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/resolve-url-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./Card.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/resolve-url-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./Card.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/*\n *+------------------------------------------------------------------------+\n *| Licensed Materials - Property of IBM\n *| IBM Cognos Products: Explore\n *| (C) Copyright IBM Corp. 2018\n *|\n *| US Government Users Restricted Rights - Use, duplication or disclosure\n *| restricted by GSA ADP Schedule Contract with IBM Corp.\n *+------------------------------------------------------------------------+\n */\n\n.ba-common-svgIcon.startingPointsThumb {\n  fill: #B07CE8;\n}\n\n.ba-common-menu__wrapper {\n  overflow: hidden !important;\n}\n\n.card {\n  background-color: white;\n  background-color: hsla(var(--ui-01-h, 0), var(--ui-01-s, 0%), var(--ui-01-l, 100%), 1);\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  width: 152px;\n  border: 1px solid;\n  border-color: #e0e0e0;\n  border-color: hsla(var(--ui-03-h, 0), var(--ui-03-s, 0%), var(--ui-03-l, 87.84314%), 1);\n  text-align: center;\n  font-size: 0.75rem;\n  height: 106px;\n  position: relative;\n  overflow: hidden;\n  cursor: pointer;\n}\n\n.card * {\n  cursor: pointer;\n}\n\n.card.is-hidden {\n  height: 16px;\n  padding: 0px;\n}\n\n.card.is-hidden .card-view {\n  display: none;\n}\n\n.card.is-hidden .card-footer {\n  height: 12px;\n}\n\n.card.is-hidden .card-footer .context-menu {\n  position: relative;\n  top: -5px;\n}\n\n.card.selected {\n  outline-style: solid;\n  outline-width: 2px;\n  outline-color: #161616;\n  outline-color: hsla(var(--ui-05-h, 0), var(--ui-05-s, 0%), var(--ui-05-l, 8.62745%), 1);\n  border-color: transparent;\n}\n\n.card svg.startingPointsThumb {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  margin-top: 22px;\n}\n\n.card .card-view {\n  -ms-flex: 1;\n      flex: 1;\n  overflow: hidden;\n  pointer-events: none;\n}\n\n.card .card-view .cardThumbnails {\n  position: relative;\n  height: 100%;\n  width: 100%;\n  display: -ms-flexbox;\n  display: flex;\n  padding: 8px;\n}\n\n.card .card-view .cardThumbnails__compare .cardThumbnails__item {\n  margin-right: 4px;\n}\n\n.card .card-view .cardThumbnails__compare .cardThumbnails__item:last-child {\n  margin-right: 0px;\n}\n\n.card .card-view .cardThumbnails__compare .cardThumbnails__item img:-moz-loading {\n  visibility: hidden;\n}\n\n.card .card-view .cardThumbnails__item {\n  width: 100%;\n  -ms-flex: 1;\n      flex: 1;\n  position: relative;\n}\n\n.card .card-view .cardThumbnails__item__error {\n  -ms-flex: 1;\n      flex: 1;\n  overflow: hidden;\n  position: relative;\n  height: 100%;\n  width: 100%;\n}\n\n.card .card-view .cardThumbnails__item__error .ba-common-decorator {\n  height: 100%;\n  width: 100%;\n}\n\n.card .card-view .cardThumbnails__item__error__icon {\n  position: absolute;\n  right: 3px;\n  top: 3px;\n  height: 20px;\n  width: 20px;\n  color: #da1e28;\n  color: hsla(var(--text-error-h, 356.80851), var(--text-error-s, 75.80645%), var(--text-error-l, 48.62745%), 1);\n}\n\n.card .card-view .cardThumbnails__item__error__icon--single {\n  top: 23px;\n  left: 110px;\n}\n\n.card .card-view .cardThumbnails__item__error__icon--left {\n  top: 21px;\n  left: 44px;\n}\n\n.card .card-view .cardThumbnails__item__error__icon--right {\n  top: 21px;\n  left: 112px;\n}\n\n.card .card-view .cardThumbnails__item__error__container {\n  position: absolute;\n  left: 10px;\n}\n\n.card .card-view .cardThumbnails__item__warning {\n  -ms-flex: 1;\n      flex: 1;\n  overflow: hidden;\n  position: relative;\n  height: 100%;\n  width: 100%;\n}\n\n.card .card-view .cardThumbnails__item__warning .ba-common-decorator {\n  height: 100%;\n  width: 100%;\n}\n\n.card .card-view .cardThumbnails__item__warning__icon {\n  position: absolute;\n  right: 3px;\n  top: 2px;\n  height: 16px;\n  width: 16px;\n  color: #f1c21b;\n  color: hsla(var(--support-03-h, 46.82243), var(--support-03-s, 88.42975%), var(--support-03-l, 52.54902%), 1);\n}\n\n.card .card-view .cardThumbnails__item__warning__icon--single {\n  top: 23px;\n  left: 110px;\n}\n\n.card .card-view .cardThumbnails__item__warning__icon--left {\n  top: 21px;\n  left: 44px;\n}\n\n.card .card-view .cardThumbnails__item__warning__icon--right {\n  top: 21px;\n  left: 112px;\n}\n\n.card .card-view .cardThumbnails__item__warning__container {\n  position: absolute;\n  left: 10px;\n}\n\n.card .card-view .cardThumbnails__item__warning .cardThumbnails__item {\n  opacity: 0.5;\n  height: 100%;\n  width: 100%;\n}\n\n.card .card-view .cardThumbnails__item img {\n  height: 100%;\n  width: 100%;\n  position: relative;\n  top: 10%;\n}\n\n.card .card-view .cardThumbnails__item img:-moz-loading {\n  visibility: hidden;\n}\n\n.card .card-view .cardThumbnails__item--default {\n  padding: 5px;\n}\n\n.card .card-view .cardThumbnails__item--blank {\n  border: 1px dashed;\n  border-color: #e0e0e0;\n  border-color: hsla(var(--ui-03-h, 0), var(--ui-03-s, 0%), var(--ui-03-l, 87.84314%), 1);\n}\n\n.card:hover .card-footer {\n  visibility: visible;\n  background-color: white;\n  background-color: hsla(var(--ui-01-h, 0), var(--ui-01-s, 0%), var(--ui-01-l, 100%), 1);\n  opacity: 0.9;\n}\n\n.card.active .card-footer {\n  opacity: 0.9;\n  display: -ms-flexbox;\n  display: flex;\n  background-color: white;\n  background-color: hsla(var(--ui-01-h, 0), var(--ui-01-s, 0%), var(--ui-01-l, 100%), 1);\n}\n\n.card .card-footer {\n  display: -ms-flexbox;\n  display: flex;\n  position: absolute;\n  width: 148px;\n  bottom: 0;\n  left: 0;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  padding: 0 5px;\n  height: 24px;\n  visibility: hidden;\n}\n\n.card .card-footer .favourite .is-on,\n.card .card-footer .favourite .is-off {\n  margin-top: 3px;\n}\n\n.card .card-footer .favourite.off .is-on {\n  display: none;\n}\n\n.card .card-footer .favourite.off:hover .is-off {\n  display: none;\n}\n\n.card .card-footer .favourite.off:hover .is-on {\n  display: block;\n}\n\n.card .card-footer .favourite.on .is-off {\n  display: none;\n}\n\n.card .card-footer .favourite.on:hover .is-on {\n  display: none;\n}\n\n.card .card-footer .favourite.on:hover .is-off {\n  display: block;\n}\n\n.card .card-footer .context-menu {\n  margin-top: 2px;\n}\n\n", ""]);

// exports


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _class2;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobx = __webpack_require__(11);

var mobx = _interopRequireWildcard(_mobx);

var _mobxReact = __webpack_require__(5);

var _reactMeasure = __webpack_require__(20);

var _reactMeasure2 = _interopRequireDefault(_reactMeasure);

var _PropTypes = __webpack_require__(1);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _Card = __webpack_require__(41);

var _Card2 = _interopRequireDefault(_Card);

var _StartingPointsCard = __webpack_require__(140);

var _StartingPointsCard2 = _interopRequireDefault(_StartingPointsCard);

var _js = __webpack_require__(64);

var _CardViewFactory = __webpack_require__(145);

var _CardViewFactory2 = _interopRequireDefault(_CardViewFactory);

var _jquery = __webpack_require__(14);

var _jquery2 = _interopRequireDefault(_jquery);

__webpack_require__(148);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /*
                                                                                                                                                           *+------------------------------------------------------------------------+
                                                                                                                                                           *| Licensed Materials - Property of IBM
                                                                                                                                                           *| IBM Cognos Products: Explore
                                                                                                                                                           *| (C) Copyright IBM Corp. 2018, 2019
                                                                                                                                                           *|
                                                                                                                                                           *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                           *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                           *+------------------------------------------------------------------------+
                                                                                                                                                           */

var BrowserUtils = __webpack_require__(150);

var LONGPRESSTIME = 500;
var SHORTPRESSTIME = 250;
var SILENT_GENERATION_SCROLL_TIMEOUT = 2000;
var SCROLL_DRAG_DISTANCE = 150;

var isFFOlderThanv60 = function isFFOlderThanv60() {
	var arr = [];
	return !arr.values;
};

var DnDHandler = function () {
	function DnDHandler(className, dropHandler, onEnterHandler, onLeaveHandler, onDragEndHandler) {
		_classCallCheck(this, DnDHandler);

		this.accepts = function () /*dragObject*/{
			return true;
		};

		this.className = className;
		this.dropHandler = dropHandler;
		this.activateDropTarget = onEnterHandler;
		this.deactivateDropTarget = onLeaveHandler;
		this.endDrag = onDragEndHandler;
	}

	DnDHandler.prototype.onDragEnd = function onDragEnd() {
		this.endDrag();
	};

	DnDHandler.prototype.onDragEnter = function onDragEnter(dragObject, dropNode) {
		this.activateDropTarget(dragObject, dropNode);
	};

	DnDHandler.prototype.onDragLeave = function onDragLeave(dragObject, dropNode) {
		this.deactivateDropTarget(dragObject, dropNode);
	};

	DnDHandler.prototype.onDrop = function onDrop(dragObject, dropNode) {
		this.dropHandler(dragObject, dropNode);
	};

	return DnDHandler;
}();

var CardList = (0, _mobxReact.observer)(_class2 = function (_Component) {
	_inherits(CardList, _Component);

	function CardList(props) {
		_classCallCheck(this, CardList);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_this.onScroll = function () {
			_this.pendingScrollTimeout = null;

			var cardsInViewport = [];
			_this.nodeMap.forEach(function (value, cardId) {
				if (_this.isInViewport(cardId) && _this.needsSilentGeneration(cardId)) {
					cardsInViewport.push(cardId);
				}
			});
			if (cardsInViewport.length > 0) {
				_this.props.cardListVM.loadCards(cardsInViewport);
			}
		};

		_this.cardViewFactory = new _CardViewFactory2.default({
			model: props.cardListVM
		});

		_this._rootRef = _react2.default.createRef();
		_this._mobxDisposeEvents = [];
		_this.listRef = null;

		_this.scrollPosition = {
			top: 0,
			left: 0
		};

		_this.nodeMap = new Map();

		_this.pendingScrollTimeout = null;

		_this.a11y = new _js.A11YCollections({
			direction: [_js.A11YDirection.UP_DOWN, _js.A11YDirection.LEFT_RIGHT],
			handlers: {
				elements: function elements(element) {
					return _this._getCardElements(element);
				},
				container: function container(element) {
					return _this._getCardContainerElement(element);
				}
			}
		});
		_this._isReadyToDrag = false;
		_this._isScrolling = false;
		return _this;
	}

	/**
  * Calculates the necessary scroll top position required to keep the selected card within the viewport.
  */


	CardList.prototype.calculateScrollTop = function calculateScrollTop(container, element) {
		if (this.shouldScrollToSelection && element && container) {
			this.shouldScrollToSelection = false;

			var scrollOffset = 0;
			var top = element.offsetTop - container.scrollTop;
			var margin = container.clientHeight / 10;

			if (top < 0) {
				scrollOffset = top - margin;
			} else if (top > container.clientHeight - element.clientHeight) {
				scrollOffset = top - container.clientHeight + margin + element.clientHeight;
			}

			if (scrollOffset) {
				var scrollTop = container.scrollTop + scrollOffset;

				return Math.max(0, scrollTop);
			}
		}
		return undefined;
	};

	CardList.prototype.scrollIfNecessary = function scrollIfNecessary() {
		if (this.listRef && this.selectedCardRef) {
			var scrollTop = this.calculateScrollTop(this.listRef, this.selectedCardRef);

			if (scrollTop !== undefined) {
				(0, _jquery2.default)(this.listRef).animate({ scrollTop: scrollTop }, 500);
			}
		}
	};

	CardList.prototype.componentDidMount = function componentDidMount() {
		var _this2 = this;

		this._dndManager = this.props.dndManager;
		this.handleSilentThumbnailGeneration();

		this._mobxDisposeEvents.push(mobx.reaction(function () {
			return _this2.props.cardListVM.selection.items.slice();
		}, function (items) {
			if (items.length === 1) {
				// When only 1 item is selected, scroll to the selection.
				_this2.shouldScrollToSelection = true;
			}
		}));

		if (this._rootRef.current) {
			this._rootRef.current.querySelector('[tabindex]').focus();
		}
	};

	CardList.prototype.componentWillUnmount = function componentWillUnmount() {
		this.listRef = null;
		this.selectedCardRef = null;

		this.scrollPosition = null;

		this._mobxDisposeEvents.forEach(function (dispose) {
			return dispose();
		});
		this._mobxDisposeEvents = [];
		clearTimeout(this._longPressTimer);
		this._longPressTimer = null;
	};

	CardList.prototype.render = function render() {
		var _this3 = this;

		var cardArray = this.props.cardListVM.getCards();
		if (!cardArray) {
			//when exploration is being closed, layout model & explore view model will get destroyed
			//cardListVM.getCards() accesses them
			return null;
		}
		var cards = this.renderItems();
		var startingPoints = this.renderStartingPoints();

		return _react2.default.createElement(
			'div',
			{
				className: 'card-list-view', ref: this._rootRef,
				tabIndex: '-1',
				onKeyDown: function onKeyDown(e) {
					return _this3.onKeyDown(e);
				}
			},
			_react2.default.createElement(
				_reactMeasure2.default,
				{
					innerRef: function innerRef(ref) {
						return _this3.listRef = ref;
					},
					onResize: function onResize() {
						return _this3.handleSilentThumbnailGeneration();
					}
				},
				function (_ref) {
					var measureRef = _ref.measureRef;
					return _react2.default.createElement(
						'div',
						{
							className: 'card-list-view__cards',
							onScroll: _this3._handleScroll.bind(_this3),
							ref: measureRef
						},
						cards
					);
				}
			),
			startingPoints
		);
	};

	CardList.prototype.canDoSilentThumbnailGeneration = function canDoSilentThumbnailGeneration() {
		var disable = BrowserUtils.isIE11() || BrowserUtils.isFirefox() && isFFOlderThanv60();
		return !disable;
	};

	CardList.prototype.needsSilentGeneration = function needsSilentGeneration(cardId) {
		if (!this.canDoSilentThumbnailGeneration()) {
			return false;
		}

		var cardListVM = this.props.cardListVM;
		var card = cardListVM.getCard(cardId);
		var widgets = card && card.items || [];

		var isStaticCard = widgets.some(function (widget) {
			return !!widget.isStaticWidget;
		});

		// if any of the widgets in the card is marked as static, we don't need silent generation
		if (isStaticCard) {
			return false;
		}

		var hasBlankWidget = cardListVM.containsBlankWidget(cardId);

		// if any of the widgets is blank (type === 'placeholder'), we don't need silent generation
		if (hasBlankWidget) {
			return false;
		}

		if (cardId === 'placeholder') {
			return false;
		}
		var node = this.nodeMap.get(cardId);
		if (node) {
			var $node = (0, _jquery2.default)(node);
			var $thumbnailItem = $node.find('.cardThumbnails__item');
			return $thumbnailItem.find('.visThumbnail').length === 0;
		} else {
			return false;
		}
	};

	CardList.prototype.isInViewport = function isInViewport(cardId) {
		if (this.listRef && this.nodeMap.has(cardId)) {

			var offset = this.listRef.scrollTop;

			var card = this.nodeMap.get(cardId).parentElement;

			var coordinates = {
				viewport: {
					top: this.listRef.offsetTop,
					bottom: this.listRef.offsetTop + this.listRef.clientHeight
				},
				card: {
					top: card.offsetTop - offset,
					bottom: card.offsetTop + card.clientHeight - offset
				}
			};

			return coordinates.card.bottom >= coordinates.viewport.top && coordinates.card.top <= coordinates.viewport.bottom;
		} else {
			return false;
		}
	};

	CardList.prototype._handleScroll = function _handleScroll() {
		this._setScrollPositionForDragSupport();
		this.handleSilentThumbnailGeneration();
	};

	CardList.prototype.handleSilentThumbnailGeneration = function handleSilentThumbnailGeneration() {
		if (this.pendingScrollTimeout) {
			clearTimeout(this.pendingScrollTimeout);
		}
		this.props.cardListVM.resetLoadingCards();
		this.pendingScrollTimeout = setTimeout(this.onScroll, SILENT_GENERATION_SCROLL_TIMEOUT);
	};

	CardList.prototype.renderItems = function renderItems() {
		var _this4 = this;

		var foundPlaceholder = false;
		var cardArray = this.props.cardListVM.getCards().filter(function (item) {
			// We only want to reveal one placeholder since we know they will always occur in a connected sequence.
			if (item.id === 'placeholder') {
				if (foundPlaceholder) {
					// We've seen a placeholder before, filter out the rest.
					return false;
				}
				foundPlaceholder = true;
			}
			return true;
		});

		var count = cardArray.length;

		var types = {
			'placeholder': function placeholder() {
				return _this4.renderPlaceholder.apply(_this4, arguments);
			}
		};

		var cards = cardArray.map(function (card, index) {
			var renderer = types[card.id];
			if (renderer) {
				return renderer(index);
			}
			return _this4.renderCard(card, count, index);
		});

		return cards;
	};

	CardList.prototype.renderCard = function renderCard(card, count, index) {
		var _this5 = this;

		var cardId = card.id;

		var showContextMenu = !this.props.cardListVM.isEditMode();
		var openContextMenu = this.props.cardListVM.shouldShowContextMenu([cardId]);
		var hasSelectedCards = this.props.cardListVM.hasSelectedCards();
		var selected = this.props.cardListVM.isCardSelected(card.id);
		var isNew = this.props.cardListVM.isCardNew(card.id);
		// The currently selected card or the last card should have tabindex="0".
		var tabIndex = !hasSelectedCards && index === count - 1 || selected ? '0' : '-1';
		var cardView = this._getCardView(card);
		var cardType = card.items.length === 1 ? 'single' : 'compare';

		return _react2.default.createElement(
			'div',
			{
				key: cardId,
				className: 'card-list-view__cards__container',
				'data-entry-type': 'card',
				'data-card-id': cardId,
				'data-card-type': cardType,
				'data-index': index + 1,
				ref: function ref(node) {
					if (node && selected && _this5.props.cardListVM.selection.items.length === 1) {
						_this5.selectedCardRef = node;
						_this5.scrollIfNecessary();
					} else if (!node) {
						_this5.selectedCardRef = node;
					}
				}
			},
			_react2.default.createElement(
				'div',
				{ className: 'card-list-view__cards__container__ordinal' },
				index + 1
			),
			_react2.default.createElement(
				'div',
				{
					className: 'card-list-view__cards__container__content',
					onMouseDown: function onMouseDown(event) {
						return _this5.onMouseDown(event, cardId);
					},
					onMouseUp: function onMouseUp(event) {
						return _this5.onMouseUp(event, cardId);
					},
					onTouchStart: function onTouchStart(event) {
						return _this5.onTouchStart(event, cardId);
					},
					onTouchEnd: function onTouchEnd(event) {
						return _this5._onTouchEnd(event, cardId);
					},
					onTouchMove: this._onTouchMove.bind(this),
					ref: function ref() {
						for (var _len = arguments.length, params = Array(_len), _key = 0; _key < _len; _key++) {
							params[_key] = arguments[_key];
						}

						return _this5._cacheNode.apply(_this5, [index, cardId].concat(params));
					}
				},
				_react2.default.createElement(_Card2.default, {
					id: cardId,
					title: card.getTitle(),
					view: cardView,
					tabIndex: tabIndex,
					isSelected: selected,
					isHidden: card.isHidden,
					hasFooter: showContextMenu,
					dndManager: this.props.dndManager,
					cacheNodeRef: function cacheNodeRef() {
						_this5.handleSilentThumbnailGeneration();
					},
					onContextMenuToggle: showContextMenu && this.props.onContextMenuToggle.bind(this.props, cardId) || undefined,
					onContextMenuChange: showContextMenu && this.props.onContextMenuChange.bind(this.props) || undefined,
					contextMenuItems: openContextMenu && this.props.handlers.getContextMenuItems([card]) || undefined
				})
			),
			isNew && _react2.default.createElement('div', { className: 'card-list-view__cards__container--isNew' })
		);
	};

	CardList.prototype.renderStartingPoints = function renderStartingPoints() {
		var _this6 = this;

		var selected = this.props.cardListVM.isStartingPointsDisplayed();
		return _react2.default.createElement(
			'div',
			{
				className: 'card-list-view__cards__container__content'
			},
			_react2.default.createElement(_StartingPointsCard2.default, {
				isSelected: selected,
				onClick: function onClick() {
					return _this6.onStartingPointsClick();
				}
			})
		);
	};

	CardList.prototype.renderPlaceholder = function renderPlaceholder(index) {
		var _this7 = this;

		var id = 'placeholder';

		return _react2.default.createElement(
			'div',
			{
				className: 'card-list-view__cards__container card-list-view__cards__container--placeholder',
				'data-entry-type': 'placeholder',
				'data-card-id': id,
				'data-index': index + 1,
				key: index
			},
			_react2.default.createElement(
				'div',
				{
					className: 'card-list-view__cards__container__content',
					ref: function ref() {
						for (var _len2 = arguments.length, params = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
							params[_key2] = arguments[_key2];
						}

						return _this7._cacheNode.apply(_this7, [index, id].concat(params));
					}
				},
				_react2.default.createElement(_Card2.default, {
					id: 'placeholder'
				})
			)
		);
	};

	// Event handlers

	CardList.prototype.onKeyDown = function onKeyDown(event) {
		switch (event.key) {
			case 'Backspace':
			case 'Delete':
				if (this.props.onDelete()) {
					event.preventDefault();
				}
				break;
			case ' ': // space
			case 'Enter':
				this._handleEnter(event);
				break;
			case 'c':
				if ((event.ctrlKey || event.metaKey) && !event.shiftKey) {
					/** ctrl + c */
					var cards = this.props.cardListVM.getSelectedCards();
					var copyAction = this.props.cardActions.getAction('copy');
					if (copyAction.isEnabled(cards)) {
						copyAction.action(cards);
					}

					event.preventDefault();
				}
				break;
			case 'a':
				if ((event.ctrlKey || event.metaKey) && !event.shiftKey) {
					/** ctrl + a */
					this.props.cardListVM.selectAll();

					event.preventDefault();
				}
				break;
			default:
				this.a11y.onKeyDown(event);
				break;
		}
	};

	CardList.prototype.onStartingPointsClick = function onStartingPointsClick() {
		this.props.cardListVM.selectStartingPoints();
	};

	CardList.prototype.onCardClick = function onCardClick(event, cardId) {
		this._setSelection(cardId, event);
	};

	CardList.prototype.startDrag = function startDrag($event, cardId) {
		var _this8 = this;

		if (!$event.currentTarget.childNodes.length) {
			return;
		}

		var element = $event.currentTarget.childNodes[0];

		var avatar = document.createElement('div');
		avatar.classList.add('card-list-view__avatar');

		var cards = void 0;
		if (this.props.cardListVM.isCardSelected(cardId)) {
			var cardElements = (0, _jquery2.default)(this.listRef).find('.card-list-view__cards__container .card.selected');
			var topAvatar = cardElements[cardElements.length - 1].cloneNode(true);

			cards = [];
			for (var i = 0; i < cardElements.length; i++) {
				cards.push(cardElements.eq(i).closest('.card-list-view__cards__container').data('card-id'));
			}

			var count = Math.min(cards.length, 3);
			var cursor = avatar;

			for (var _i = 0; _i < count; _i++) {
				var holder = document.createElement('div');
				holder.classList.add('card-list-view__avatar__container');

				var relative = document.createElement('div');
				relative.classList.add('card-list-view__avatar__relative');

				var node = void 0;
				if (_i < count - 1) {
					node = document.createElement('div');
					node.classList.add('card');
					node.classList.add('selected');
				} else {
					node = topAvatar;
				}

				relative.appendChild(node);
				holder.appendChild(relative);
				cursor.appendChild(holder);

				cursor = holder;
			}
		} else {
			cards = [cardId];

			avatar.appendChild(element.cloneNode(true));
		}

		// not too happy to do this ↓ , perhaps we need to augment DNDManager to be able to set these properly
		avatar.style.position = 'absolute'; // dnd expects avatar position:absolute
		avatar.style.zIndex = '10000';

		this._dndManager.startDrag({
			event: $event,
			avatar: avatar,
			type: 'card',
			data: cards,
			avatarXOffset: -(element.offsetWidth / 2),
			avatarYOffset: -(element.offsetHeight / 2),
			moveXThreshold: 20,
			moveYThreshold: 20,
			callerCallbacks: {
				onDragStart: function onDragStart() {
					_this8.props.cardListVM.beginDrag(cards);
				},
				onMove: function onMove(event, options) {
					_this8._handleScrollDrag($event, options);
				},
				onDragDone: function onDragDone(event, options) {
					_this8.props.cardListVM.endDrag();

					(0, _jquery2.default)(options.dragObject.avatar).hide();

					// Have to also reset the flag here, because after dragging a card,
					// the onMouseUp or onTouchEnd callback of the dragged card will not get called
					_this8._isReadyToDrag = false;
					_this8._isLongPress = false;
				}
			}
		});
	};

	CardList.prototype._handleScrollDrag = function _handleScrollDrag(movedCardEvent, options) {
		var dragObject = options.dragObject;
		var scrollableContainer = this.listRef;
		var boundingRect = scrollableContainer.getBoundingClientRect();
		var rect = {
			top: boundingRect.top,
			bottom: boundingRect.bottom
		};
		var position = dragObject.position;
		var distanceBottom = rect.bottom - position.y;
		var distanceTop = position.y - rect.top;
		// Determine whether drag direction is to the top or bottom
		// isScrollingBottom when the distance of the dragged card to the bottom of the container
		// is between 0 and SCROLL_DRAG_DISTANCE (i.e. scroll distance buffer for scrolling 150)
		var isScrollingBottom = distanceBottom > 0 && distanceBottom < SCROLL_DRAG_DISTANCE;
		// isScrollingTop when the distance of the dragged card to the top of the container
		// is between 0 and SCROLL_DRAG_DISTANCE (i.e. scroll distance buffer for scrolling 150)
		var isScrollingTop = distanceTop > 0 && distanceTop < SCROLL_DRAG_DISTANCE;
		var distanceY = 0;
		// If both isScrollingTop and isScrollingBottom are true (almost never happens), choose scrolling direction based on the larger distance
		if (isScrollingTop && isScrollingBottom) {
			isScrollingTop = distanceTop > distanceBottom;
			isScrollingBottom = !isScrollingTop;
		}
		if (isScrollingBottom) {
			distanceY = SCROLL_DRAG_DISTANCE - distanceBottom;
		} else if (isScrollingTop) {
			distanceY = distanceTop - SCROLL_DRAG_DISTANCE;
		}
		scrollableContainer.scrollTop += distanceY;

		var deltaScrollTop = this.scrollPosition.top - scrollableContainer.scrollTop;
		var deltaScrollLeft = this.scrollPosition.left - scrollableContainer.scrollLeft;

		// Add change in scrollTop and scrollLeft to cached clientRects of moved card in dndManager
		if (movedCardEvent.currentTarget) {
			var movedCardCandidateDropTarget = this._dndManager.getCandidateDropTargetFromNode(movedCardEvent.currentTarget);
			if (movedCardCandidateDropTarget) {
				movedCardCandidateDropTarget.clientRects.forEach(function (clientRect) {
					clientRect.top += deltaScrollTop;
					clientRect.left += deltaScrollLeft;
				});
			}
		}

		// Add change in scrollTop and scrollLeft to cached clientRects of children of cardList
		this._dndManager.scrollChildrenCandidateDropTargets(scrollableContainer, deltaScrollTop, deltaScrollLeft);

		this._setScrollPositionForDragSupport();
	};

	CardList.prototype._setScrollPositionForDragSupport = function _setScrollPositionForDragSupport() {
		if (this.listRef) {
			this.scrollPosition = {
				top: this.listRef.scrollTop,
				left: this.listRef.scrollLeft
			};
		}
	};

	CardList.prototype.onMouseDown = function onMouseDown(event, cardId) {
		var _this9 = this;

		var isMobile = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

		if ((0, _jquery2.default)(event.target).closest('.ba-common-context-menu').length > 0) {
			return;
		}
		event.persist();
		// ↓ caching event.currentTarget which used by DnDManager
		var $event = _jquery2.default.Event(event.type, event);
		var callback = function callback(e) {
			var isCardSelected = _this9.props.cardListVM.isCardSelected(cardId);
			_this9._isLongPress = true;
			if (isMobile) {
				if (!isCardSelected && !_this9.props.cardListVM.isDragging()) {
					_this9.onCardClick(event, cardId);
				}
			} else {
				// ↓ dont drag on context menu actions
				if (!(0, _jquery2.default)(e.target).hasClass('ba-common-menu__item') && (0, _jquery2.default)(e.target).parents('.ba-common-menu__item').length === 0) {
					_this9.startDrag(e, cardId);
				}
			}
		};
		this._longPressTimer = setTimeout(callback, isMobile ? LONGPRESSTIME : SHORTPRESSTIME, $event);
		if (isMobile) {
			this._mobileStartDragTimer = setTimeout(function ($event) {
				_this9.startDrag($event, cardId);
				_this9._isReadyToDrag = true;
			}, SHORTPRESSTIME, $event);
		}
	};

	CardList.prototype._onTouchMove = function _onTouchMove() {
		if (this._isReadyToDrag || this._isScrolling) {
			// If already in dragging status or scrolling status, do nothing
			return;
		} else {
			// Not ready to drag, then do scrolling
			// set scrolling status to true
			this._isScrolling = true;
			if (this._mobileStartDragTimer) {
				clearTimeout(this._mobileStartDragTimer);
				this._mobileStartDragTimer = null;
			}
			if (this._longPressTimer) {
				clearTimeout(this._longPressTimer);
				this._longPressTimer = null;
			}
		}
	};

	CardList.prototype.onMouseUp = function onMouseUp(event, cardId) {
		if (this._isLongPress) {
			this._isLongPress = false;
		} else {
			this.onCardClick(event, cardId);
		}
		clearTimeout(this._longPressTimer);
		this._longPressTimer = null;
		// Prevents the mouse up event when touch event happens
		event.preventDefault();
	};

	CardList.prototype.onTouchStart = function onTouchStart(event, cardId) {
		this.onMouseDown(event, cardId, true);
	};

	// Private

	CardList.prototype._onTouchEnd = function _onTouchEnd(event, cardId) {
		if (this._isScrolling) {
			this._isScrolling = false;
		} else {
			if (this._isReadyToDrag) {
				this._isReadyToDrag = false;
			}
			if (this._isLongPress) {
				this._isLongPress = false;
			} else {
				// make sure event is NOT coming from the context menu, but from click on the actual card
				if (!(0, _jquery2.default)(event.target).parents('.ba-common-menu__item').length) {
					this.onCardClick(event, cardId);
				}
			}
			clearTimeout(this._longPressTimer);
			this._longPressTimer = null;
			clearTimeout(this._mobileStartDragTimer);
			this._mobileStartDragTimer = null;
		}
		// Prevents the mouse up event when touch event happens
		if (event.cancelable !== false) {
			event.preventDefault();
		}
	};

	CardList.prototype._isCardElement = function _isCardElement(element) {
		return this._getCardContainerElement(element).data('entry-type') === 'card';
	};

	CardList.prototype._getCardView = function _getCardView(card) {
		return this.cardViewFactory.makeCardView(card);
	};

	CardList.prototype._getCardContainerElement = function _getCardContainerElement(element) {
		return (0, _jquery2.default)(element).closest('.card-list-view__cards__container');
	};

	CardList.prototype._isStartingPointsElement = function _isStartingPointsElement(element) {
		return this._getCardContainerElement(element).data('entry-type') === 'starting-points';
	};

	CardList.prototype._getCardElements = function _getCardElements(element) {
		return (0, _jquery2.default)(element).closest('.card-list-view').find('.card-list-view__cards__container .card');
	};

	CardList.prototype._getCardId = function _getCardId(element) {
		var container = this._getCardContainerElement(element);
		return container.data('card-id');
	};

	CardList.prototype._handleEnter = function _handleEnter(event) {
		if (this._isCardElement(event.target)) {
			var id = this._getCardId(event.target);
			if (id) {
				this._setSelection(id, event);

				event.preventDefault();
			}
		} else if (this._isStartingPointsElement(event.target)) {
			this.props.cardListVM.selectStartingPoints();

			event.preventDefault();
		}
	};

	CardList.prototype._setSelection = function _setSelection(id, event) {
		var multiselect = event.ctrlKey || event.metaKey || this._isLongPress;
		var rangeselect = event.shiftKey && !multiselect;

		this.props.cardListVM.selectCard(id, {
			multiselect: multiselect,
			rangeselect: rangeselect
		});
	};

	CardList.prototype._cacheNode = function _cacheNode(index, cardId, node) {
		var _this10 = this;

		var previousNode = this.nodeMap.get(cardId);

		if (previousNode) {
			this.nodeMap.delete(cardId);

			this.props.dndManager && this.props.dndManager.removeDropTarget(previousNode);
		}

		if (node) {
			this.nodeMap.set(cardId, node);

			this.props.dndManager && this.props.dndManager.addDropTarget(node, new DnDHandler('dndHover', function () {
				for (var _len3 = arguments.length, params = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
					params[_key3] = arguments[_key3];
				}

				return _this10._handleOnDrop.apply(_this10, [index].concat(params));
			}, function () {
				for (var _len4 = arguments.length, params = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
					params[_key4] = arguments[_key4];
				}

				return _this10._handleOnDragEnter.apply(_this10, [cardId].concat(params));
			}, function () {
				for (var _len5 = arguments.length, params = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
					params[_key5] = arguments[_key5];
				}

				return _this10._handleOnDragLeave.apply(_this10, [index].concat(params));
			}, function () {
				for (var _len6 = arguments.length, params = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
					params[_key6] = arguments[_key6];
				}

				return _this10._handleOnDragEnd.apply(_this10, [index].concat(params));
			}));
		}
	};

	CardList.prototype._handleOnDrop = function _handleOnDrop() {
		return;
	}; // leaving definition for potential future use(widget to explore drop)

	CardList.prototype._handleOnDragEnter = function _handleOnDragEnter(cardId) {
		this.props.cardListVM.movePlaceHolderToCard(cardId);
	};

	CardList.prototype._handleOnDragLeave = function _handleOnDragLeave() {
		return;
	}; // leaving definition for potential future use(widget to explore drop)

	CardList.prototype._handleOnDragEnd = function _handleOnDragEnd() {
		return;
	}; // end drag is handled by the callback onDragDone in startDrag in this class

	return CardList;
}(_react.Component)) || _class2;

CardList.propTypes = {
	handlers: _PropTypes2.default.object,
	cardListVM: _PropTypes2.default.object.isRequired,
	cardActions: _PropTypes2.default.object.isRequired,
	thumbnails: _PropTypes2.default.object,
	onContextMenuToggle: _PropTypes2.default.func,
	onContextMenuChange: _PropTypes2.default.func,
	onDelete: _PropTypes2.default.func,
	dndManager: _PropTypes2.default.object.isRequired,
	dndThresholdPx: _PropTypes2.default.number
};

CardList.defaultProps = {
	onContextMenuToggle: function onContextMenuToggle() {},
	onContextMenuChange: function onContextMenuChange() {},
	dndThresholdPx: 10
};

exports.default = CardList;

/***/ }),
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _caUiToolkit = __webpack_require__(6);

var _PropTypes = __webpack_require__(1);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _Card = __webpack_require__(41);

var _Card2 = _interopRequireDefault(_Card);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

var _dataRelationshipsCard_ = __webpack_require__(43);

var _dataRelationshipsCard_2 = _interopRequireDefault(_dataRelationshipsCard_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| IBM Cognos Products: Explore
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| (C) Copyright IBM Corp. 2018
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *|
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var StartingPointsCard = function (_Component) {
	_inherits(StartingPointsCard, _Component);

	function StartingPointsCard(props) {
		_classCallCheck(this, StartingPointsCard);

		return _possibleConstructorReturn(this, _Component.call(this, props));
	}

	StartingPointsCard.prototype.render = function render() {
		var _props = this.props,
		    onClick = _props.onClick,
		    isSelected = _props.isSelected;


		var spTitle = _StringResources2.default.get('startingPoints_data_relationships_thumbnail_title');
		var view = _react2.default.createElement(_caUiToolkit.SVGIcon, { className: 'startingPointsThumb', iconId: _dataRelationshipsCard_2.default.id, width: 128, height: 74 });

		return _react2.default.createElement(
			'div',
			{
				className: 'card-list-view__starting-points',
				'data-entry-type': 'starting-points',
				title: spTitle,
				'aria-label': spTitle
			},
			_react2.default.createElement(_Card2.default, {
				id: 'starting_points',
				title: spTitle,
				tabIndex: '0',
				hasFooter: false,
				isSelected: isSelected,
				onClick: onClick,
				view: view })
		);
	};

	return StartingPointsCard;
}(_react.Component);

StartingPointsCard.propTypes = {
	onClick: _PropTypes2.default.func,
	isSelected: _PropTypes2.default.bool
};

_Card2.default.defaultProps = {
	onClick: function onClick() {},
	isSelected: true
};

exports.default = StartingPointsCard;

/***/ }),
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(10);

var _classnames2 = _interopRequireDefault(_classnames);

var _underscore = __webpack_require__(8);

var _underscore2 = _interopRequireDefault(_underscore);

var _CardView = __webpack_require__(65);

var _CardView2 = _interopRequireDefault(_CardView);

var _WarningCardView = __webpack_require__(146);

var _WarningCardView2 = _interopRequireDefault(_WarningCardView);

var _BlankCardView = __webpack_require__(66);

var _BlankCardView2 = _interopRequireDefault(_BlankCardView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /*
                                                                                                                                                           *+------------------------------------------------------------------------+
                                                                                                                                                           *| Licensed Materials - Property of IBM
                                                                                                                                                           *| IBM Cognos Products: Explore
                                                                                                                                                           *| (C) Copyright IBM Corp. 2018
                                                                                                                                                           *|
                                                                                                                                                           *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                           *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                           *+------------------------------------------------------------------------+
                                                                                                                                                           */


var CardViewFactory = function () {
	function CardViewFactory() {
		var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
		    model = _ref.model;

		_classCallCheck(this, CardViewFactory);

		if (!model) {
			throw new Error('Invalid model provided to factory');
		}

		this.model = model;
	}

	/**
  * Make card view
  *
  * @param {Card} card - card instance
  * @return {React.Component} manufactured card view
  */


	CardViewFactory.prototype.makeCardView = function makeCardView(card) {
		var thumbnails = void 0;
		if (card.isCompareEnabled) {
			thumbnails = this.makeCompareCardView(card) || [];
		} else {
			thumbnails = this.makeSingleCardView(card) || [];
		}

		if (thumbnails.length === 0) {
			thumbnails.push(_react2.default.createElement(_BlankCardView2.default, {
				key: _underscore2.default.uniqueId('blank_')
			}));
		}

		var classes = (0, _classnames2.default)({
			cardThumbnails: true,
			cardThumbnails__compare: card.isCompareEnabled,
			cardThumbnails__single: !card.isCompareEnabled
		});

		return _react2.default.createElement(
			'div',
			{ className: classes },
			thumbnails
		);
	};

	/**
  * Make compare card view
  *
  * @param {Card} card - card instance
  * @return {React.Component} manufactured compare card view
  */


	CardViewFactory.prototype.makeCompareCardView = function makeCompareCardView(card) {
		var _this = this;

		return card.getVisualizations().map(function (visualization) {
			if (visualization.widgetLayout) {
				var widgetLayout = visualization.widgetLayout;

				var widgetThumbnail = _this.model.thumbnails.getItemByWidgetId(widgetLayout.id);
				if (widgetThumbnail) {
					if (widgetThumbnail.hasError() || widgetThumbnail.hasWarning()) {
						return _this.makeWarningView(widgetThumbnail);
					} else {
						return _this.makeSuccessCardView(widgetThumbnail, widgetLayout.id);
					}
				} else {
					return _this.makeBlankCardView();
				}
			} else if (visualization.placeholder) {
				return _this.makeBlankCardView();
			}
		});
	};

	/**
  * Make single card view
  *
  * @param {Card} card - card instance
  * @return {React.Component} manufactured single card view
  */


	CardViewFactory.prototype.makeSingleCardView = function makeSingleCardView(card) {
		var thumbnail = void 0;
		var visualizations = card.getVisualizations();
		if (visualizations.length === 0) {
			return;
		}

		var firstWidgetLayout = visualizations[0].widgetLayout;
		if (!firstWidgetLayout) {
			return;
		}

		var widgetThumbnail = this.model.thumbnails.getItemByWidgetId(firstWidgetLayout.id);
		if (!widgetThumbnail) {
			return;
		}

		if (widgetThumbnail.hasError() || widgetThumbnail.hasWarning()) {
			thumbnail = this.makeWarningView(widgetThumbnail);
		} else {
			thumbnail = this.makeSuccessCardView(widgetThumbnail, firstWidgetLayout.id);
		}

		if (thumbnail) {
			return [thumbnail];
		}
	};

	CardViewFactory.prototype.makeWarningView = function makeWarningView(thumbnail) {
		return _react2.default.createElement(_WarningCardView2.default, {
			key: _underscore2.default.uniqueId('warning_'),
			thumbnail: thumbnail
		});
	};

	CardViewFactory.prototype.makeSuccessCardView = function makeSuccessCardView(thumbnail, key) {
		return _react2.default.createElement(_CardView2.default, {
			key: key,
			thumbnail: thumbnail
		});
	};

	CardViewFactory.prototype.makeBlankCardView = function makeBlankCardView() {
		return _react2.default.createElement(_BlankCardView2.default, {
			key: _underscore2.default.uniqueId('blank_')
		});
	};

	return CardViewFactory;
}();

exports.default = CardViewFactory;

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(10);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _caUiToolkit = __webpack_require__(6);

var _warningAlt_ = __webpack_require__(147);

var _warningAlt_2 = _interopRequireDefault(_warningAlt_);

var _CardView = __webpack_require__(65);

var _CardView2 = _interopRequireDefault(_CardView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| IBM Cognos Products: Explore
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| (C) Copyright IBM Corp. 2019
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *|
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var WarningCardView = function (_Component) {
	_inherits(WarningCardView, _Component);

	function WarningCardView() {
		_classCallCheck(this, WarningCardView);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	WarningCardView.prototype.render = function render() {
		var thumbnail = this.props.thumbnail;
		var classes = (0, _classnames2.default)({
			cardThumbnails__item__warning: true
		});

		return _react2.default.createElement(
			'div',
			{
				className: classes },
			this._renderWarningIcon(),
			_react2.default.createElement(_CardView2.default, {
				key: thumbnail.widgetId,
				thumbnail: thumbnail
			})
		);
	};

	WarningCardView.prototype._renderWarningIcon = function _renderWarningIcon() {
		return _react2.default.createElement(_caUiToolkit.SVGIcon, {
			className: 'cardThumbnails__item__warning__icon',
			iconId: _warningAlt_2.default.id
		});
	};

	return WarningCardView;
}(_react.Component);

WarningCardView.propTypes = {
	thumbnail: _propTypes2.default.shape({
		type: _propTypes2.default.string,
		widgetId: _propTypes2.default.string
	})
};

exports.default = WarningCardView;

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "warning--alt_16",
  "use": "warning--alt_16-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"warning--alt_16\"><path d=\"M14.5 14h-13c-.2 0-.3-.1-.4-.2-.1-.2-.1-.3 0-.5l6.5-12c.1-.3.4-.4.6-.2.1 0 .2.1.2.2l6.5 12c.1.2.1.3 0 .5 0 .1-.2.2-.4.2zM2.3 13h11.3L8 2.5 2.3 13z\" /><path d=\"M7.5 6h1v3.5h-1zm.5 4.8c-.4 0-.8.3-.8.8s.3.8.8.8c.4 0 .8-.3.8-.8s-.4-.8-.8-.8z\" /><path style=\"fill:none\" d=\"M0 0h16v16H0z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(149);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/resolve-url-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./CardList.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/resolve-url-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./CardList.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/*\n *+------------------------------------------------------------------------+\n *| Licensed Materials - Property of IBM\n *| IBM Cognos Products: Explore\n *| (C) Copyright IBM Corp. 2018\n *|\n *| US Government Users Restricted Rights - Use, duplication or disclosure\n *| restricted by GSA ADP Schedule Contract with IBM Corp.\n *+------------------------------------------------------------------------+\n */\n\n.card-list-view {\n  padding-top: 16px;\n  max-height: 100%;\n  width: 100%;\n  -ms-flex-positive: 1;\n      flex-grow: 1;\n  -ms-flex-negative: 1;\n      flex-shrink: 1;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n}\n\n.card-list-view__cards {\n  position: relative;\n  -ms-flex-positive: 0;\n      flex-grow: 0;\n  -ms-flex-negative: 1;\n      flex-shrink: 1;\n  min-height: 0;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: row;\n      flex-direction: row;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  overflow-y: auto;\n  padding: 5px 0;\n}\n\n.card-list-view__cards__container {\n  position: relative;\n}\n\n.card-list-view__cards__container--placeholder {\n  opacity: 0;\n}\n\n.card-list-view__cards__container--isNew {\n  background-color: #24a148;\n  background-color: hsla(var(--support-02-h, 137.28), var(--support-02-s, 63.45178%), var(--support-02-l, 38.62745%), 1);\n  position: absolute;\n  border-radius: 50%;\n  top: -5px;\n  right: -5px;\n  width: 10px;\n  height: 10px;\n  border-style: solid;\n  border-color: #24a148;\n  border-color: hsla(var(--support-02-h, 137.28), var(--support-02-s, 63.45178%), var(--support-02-l, 38.62745%), 1);\n  border-width: thick;\n}\n\n.card-list-view__cards__container__ordinal {\n  position: absolute;\n  bottom: 16px;\n  left: 10px;\n  direction: rtl;\n  width: 8px;\n  font-size: 0.75rem;\n  font-weight: bold;\n}\n\n.card-list-view__cards__container__content {\n  margin-bottom: 16px;\n  margin-left: 24px;\n}\n\n.card-list-view__starting-points {\n  -ms-flex-positive: 0;\n      flex-grow: 0;\n  -ms-flex-negative: 0;\n      flex-shrink: 0;\n  margin-top: 10px;\n}\n\n.card-list-view__avatar__container {\n  position: absolute;\n  top: 8px;\n  left: 8px;\n}\n\n.card-list-view__avatar__relative {\n  position: relative;\n}\n\n", ""]);

// exports


/***/ }),
/* 150 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_150__;

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _class; /*
             *+------------------------------------------------------------------------+
             *| Licensed Materials - Property of IBM
             *| IBM Cognos Products: Explore
             *| (C) Copyright IBM Corp. 2018, 2019
             *|
             *| US Government Users Restricted Rights - Use, duplication or disclosure
             *| restricted by GSA ADP Schedule Contract with IBM Corp.
             *+------------------------------------------------------------------------+
             */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(5);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _overflowMenuHorizontal_ = __webpack_require__(152);

var _overflowMenuHorizontal_2 = _interopRequireDefault(_overflowMenuHorizontal_);

var _ContextMenuIcon = __webpack_require__(62);

var _ContextMenuIcon2 = _interopRequireDefault(_ContextMenuIcon);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SidePaneHeader = (0, _mobxReact.observer)(_class = function (_Component) {
	_inherits(SidePaneHeader, _Component);

	function SidePaneHeader() {
		var _temp, _this, _ret;

		_classCallCheck(this, SidePaneHeader);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.onContextMenuToggle = function (toggle) {
			var cardListVM = _this.props.cardListVM;
			var exploreVM = cardListVM.exploreVM;

			var ids = toggle ? exploreVM.selectedCards.items : null;

			cardListVM.showContextMenu(ids);
		}, _this.cancelEditMode = function () {
			var cardListVM = _this.props.cardListVM;

			cardListVM.clearSelection();
			cardListVM.clearContextMenu();
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	SidePaneHeader.prototype.render = function render() {
		var cardListVM = this.props.cardListVM;


		var isEditMode = cardListVM.isEditMode();

		var leftSection = this.renderLeftSection(isEditMode);
		var title = this.renderTitle(isEditMode);
		var rightSection = this.renderRightSection(isEditMode);

		return _react2.default.createElement(
			'div',
			{ className: 'sidePane__header' },
			leftSection,
			title,
			rightSection
		);
	};

	SidePaneHeader.prototype.renderLeftSection = function renderLeftSection(isEditMode) {
		if (isEditMode) {
			return _react2.default.createElement(
				'div',
				{
					className: 'sidePane__header__leftButton',
					onClick: this.cancelEditMode
				},
				_StringResources2.default.get('cancel_multiselect')
			);
		} else {
			return undefined;
		}
	};

	SidePaneHeader.prototype.renderRightSection = function renderRightSection(isEditMode) {
		var cardListVM = this.props.cardListVM;


		var showContextMenu = cardListVM.shouldShowContextMenu();

		if (isEditMode) {
			return _react2.default.createElement(_ContextMenuIcon2.default, {
				iconId: _overflowMenuHorizontal_2.default.id,
				items: showContextMenu ? this.getContextMenuItems() : undefined,
				onChange: this.props.onContextMenuChange,
				onToggle: this.onContextMenuToggle,
				thumbnails: cardListVM.thumbnails
			});
		} else {
			return undefined;
		}
	};

	SidePaneHeader.prototype.renderTitle = function renderTitle(isEditMode) {
		var title = !isEditMode && _StringResources2.default.get('cardListTitle');
		return _react2.default.createElement(
			'div',
			{ className: 'sidePane__header__title' },
			title
		);
	};

	// Events

	// Internal

	SidePaneHeader.prototype.getContextMenuItems = function getContextMenuItems(cards) {
		return this.props.cardListVM.getContextMenuItems(cards);
	};

	return SidePaneHeader;
}(_react.Component)) || _class;

SidePaneHeader.propTypes = {
	cardListVM: _propTypes2.default.object.isRequired,
	onContextMenuChange: _propTypes2.default.func
};

SidePaneHeader.defaultProps = {
	onContextMenuChange: function onContextMenuChange() {}
};

exports.default = SidePaneHeader;

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "overflow-menu--horizontal_32",
  "use": "overflow-menu--horizontal_32-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"overflow-menu--horizontal_32\"><circle cx=\"6\" cy=\"16\" r=\"2\" /><circle cx=\"16\" cy=\"16\" r=\"2\" /><circle cx=\"26\" cy=\"16\" r=\"2\" /><path style=\"fill:none\" d=\"M0 32V0h32v32z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(154);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/resolve-url-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./SidePane.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/resolve-url-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./SidePane.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/*\n *+------------------------------------------------------------------------+\n *| Licensed Materials - Property of IBM\n *| IBM Cognos Products: Explore\n *| (C) Copyright IBM Corp. 2018\n *|\n *| US Government Users Restricted Rights - Use, duplication or disclosure\n *| restricted by GSA ADP Schedule Contract with IBM Corp.\n *+------------------------------------------------------------------------+\n */\n\n.sidePane {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  height: 100%;\n}\n\n.sidePane__header {\n  margin: 0 24px;\n  border-bottom: 1px solid;\n  border-bottom-color: #e0e0e0;\n  border-bottom-color: hsla(var(--ui-03-h, 0), var(--ui-03-s, 0%), var(--ui-03-l, 87.84314%), 1);\n  -ms-flex-positive: 0;\n      flex-grow: 0;\n  -ms-flex-negative: 0;\n      flex-shrink: 0;\n  display: -ms-flexbox;\n  display: flex;\n  height: 48px;\n  -ms-flex-align: center;\n      align-items: center;\n}\n\n.sidePane__header__leftButton {\n  color: #0f62fe;\n  color: hsla(var(--interactive-01-h, 219.16318), var(--interactive-01-s, 99.17012%), var(--interactive-01-l, 52.7451%), 1);\n  font-size: 0.875rem;\n  cursor: pointer;\n}\n\n.sidePane__header__title {\n  color: #393939;\n  color: hsla(var(--text-02-h, 0), var(--text-02-s, 0%), var(--text-02-l, 22.35294%), 1);\n  -ms-flex: 1;\n      flex: 1;\n  text-align: left;\n  font-size: 0.875rem;\n  font-weight: 700;\n}\n\n.sidePane__icon {\n  cursor: pointer;\n}\n\n.sidePane__icon--back {\n  margin-top: 5px;\n}\n\n.sidePane__content {\n  -ms-flex-positive: 1;\n      flex-grow: 1;\n  -ms-flex-negative: 1;\n      flex-shrink: 1;\n  display: -ms-flexbox;\n  display: flex;\n  overflow: hidden;\n}\n\n", ""]);

// exports


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _mobx = __webpack_require__(11);

var mobx = _interopRequireWildcard(_mobx);

var _mobxStateTree = __webpack_require__(7);

var _underscore = __webpack_require__(8);

var _underscore2 = _interopRequireDefault(_underscore);

var _ThumbnailsModel = __webpack_require__(156);

var _ThumbnailsModel2 = _interopRequireDefault(_ThumbnailsModel);

var _ArrayOperations = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var CONTEXT_MENU_STRUCTURE = [['copy', 'paste'], null, //separator
['duplicate', 'show', 'hide', 'compare'], null, //separator
['deleteCard']];

/**
 *
 * @private
 * @param {string[]} currentItems - ids of the current displayed items
 * @param {string[]} placeHolders - ids of the items in the placeHolder
 * @param {integer} firstPlaceHolderIndex - index in the first placeHolder item in the list of currentItems
 * @param {string} targetCardId - id of the card/item when the placeHolder is to go
 * @returns {string[]} - new array of items id where the the placeholder takes the position of the specified card
 * @example
 *  // target card is before the first one in the placeholder; target card pushed to the right
 *  buildNewDisplayedItems(['a', 'b', 'c', 'd'], ['c'], 2, 'a') returns ['c', 'a', 'b', 'd']
 *  // target card is after the first element in the placeholder, target card pushed to the left
 *  buildNewDisplayedItems(['a', 'b', 'c', 'd'], ['b'], 1, 'c') returns ['a', 'c', 'b', 'd']
 *  //multiple items in the placeholders
 *  buildNewDisplayedItems(['a', 'b', 'c', 'd', 'e'], ['b', 'e'], 1, 'c') returns ['a', 'c', 'b', 'e', 'd']
 *
 */
/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018, 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

var buildNewDisplayedItems = function buildNewDisplayedItems(currentItems, placeHolders, firstPlaceHolderIndex, targetCardId) {
	var displayedItems = [];
	for (var j = 0; j < currentItems.length; j++) {
		var itemId = currentItems[j];
		if (placeHolders.indexOf(itemId) < 0) {
			if (itemId !== targetCardId) {
				displayedItems.push(itemId);
			} else {
				if (j >= firstPlaceHolderIndex) {
					displayedItems.push(itemId);
					displayedItems = displayedItems.concat(placeHolders);
				} else {
					displayedItems = displayedItems.concat(placeHolders);
					displayedItems.push(itemId);
				}
			}
		}
	}
	return displayedItems;
};

exports.default = _mobxStateTree.types.model('CardListViewModel', {
	thumbnails: _ThumbnailsModel2.default
}).volatile(function () {
	return {
		_isAlive: _mobxStateTree.isAlive,
		isDragged: false,
		selection: null,
		placeholders: [],
		items: mobx.observable([]),
		layoutModel: null,
		exploreVM: null,
		contextMenu: null,
		_mobxDisposeEvents: []
	};
}).views(function (self) {
	return {
		/**
   * Returns whether there are card(s) selected or not.
   * @param {string} id - id of card to test whether it is selected
   * @return {boolean}
   */
		hasSelectedCards: function hasSelectedCards() {
			return self.selection.hasSelections();
		},

		/**
   * Determine if a card is selected
   * @param {string} id - id of card to test whether it is selected
   * @return {boolean}
   */
		isCardSelected: function isCardSelected(id) {
			return self.selection.isSelected(id);
		},
		isEditMode: function isEditMode() {
			return self.selection.items.length > 1 || self.hasSelectedCards() && self.selection.items[0] !== self.exploreVM.displayedCard;
		},
		shouldShowContextMenu: function shouldShowContextMenu(ids) {
			ids = ids || self.selection.items;

			return !!self.contextMenu && _underscore2.default.intersection(ids, self.contextMenu).length === ids.length;
		},
		isStartingPointsDisplayed: function isStartingPointsDisplayed() {
			return self.exploreVM.isStartingPointsDisplayed();
		},
		getSelectedCards: function getSelectedCards() {
			return self.selection.items.map(function (id) {
				return self.layoutModel.findModel(id);
			});
		},
		getContextMenuItems: function getContextMenuItems(cards) {
			cards = cards || self.getSelectedCards();

			var actionDescriptors = (0, _mobxStateTree.getEnv)(self).cardActions.getActions(cards);

			return CONTEXT_MENU_STRUCTURE.map(function (menuItems) {
				if (!menuItems) {
					return {}; //Represents a separator
				}

				var items = menuItems.map(function (menuItem) {
					return actionDescriptors.find(function (descriptor) {
						return descriptor.id === menuItem;
					});
				}).filter(function (actionDescriptor) {
					return !!actionDescriptor;
				}).map(function (actionDescriptor) {
					return {
						id: actionDescriptor.id,
						value: actionDescriptor.id,
						label: actionDescriptor.label
					};
				});

				return { items: items };
			});
		},
		performAction: function performAction(actionId, cards) {
			cards = cards || self.getSelectedCards();

			var actionDescriptor = (0, _mobxStateTree.getEnv)(self).cardActions.getAction(actionId);
			actionDescriptor.action(cards);
		},

		/**
   * Return card item array
   */
		getCards: function getCards() {
			var depModelsAlive = function depModelsAlive() {
				return self._isAlive(self.layoutModel) && self._isAlive(self.exploreVM);
			};
			if (!depModelsAlive()) {
				return null;
			}
			return self.items.map(function (id) {
				if (self.placeholders.indexOf(id) !== -1) {
					return { id: 'placeholder' };
				}
				return self.layoutModel.findModel(id);
			});
		},

		/**
   * Find the index of the child in the item array
   * @param {Object} item with an id attribute
   */
		getItemIndex: function getItemIndex(id) {
			if (self.items) {
				return self.items.indexOf(id);
			}
			return -1;
		},

		/**
   * @param {String} id of the Card
   * Return Card object
   */
		getCard: function getCard(id) {
			return self.layoutModel.findModel(id);
		},
		isDragging: function isDragging() {
			return self.isDragged;
		}
	};
}).actions(function (self) {
	return {
		beforeDestroy: function beforeDestroy() {
			self._mobxDisposeEvents.forEach(function (dispose) {
				return dispose();
			});
		},
		setModelChecker: function setModelChecker(isAlive) {
			self._isAlive = isAlive;
		},
		setLayoutModel: function setLayoutModel(layoutModel) {
			self.layoutModel = layoutModel;
			self.exploreVM = layoutModel.exploreVM;

			self._mobxDisposeEvents.push(mobx.reaction(function () {
				return self.layoutModel.items.map(function (item) {
					return item.id;
				});
			}, function (latestItemIds) {
				setItems(self.items, latestItemIds);
			}, {
				fireImmediately: true
			}));

			// Sync the selection with the displayed card.
			self._mobxDisposeEvents.push(mobx.reaction(function () {
				return self.exploreVM.displayedCard;
			}, function () {
				if (self.contextMenu && self.contextMenu[0] !== self.exploreVM.displayedCard) {
					self.showContextMenu(null);
				}
			}, { delay: 200 }));
		},
		setSelectionModel: function setSelectionModel(selectionModel) {
			self.selection = selectionModel;
		},

		/**
   * Modify current selection by toggling one card
   * @param {string} cardId - id of card to select
   * @param {object} [options]
   * @param {boolean} [options.multiselect=false] - indicates the user has depressed the multiselect key (cmd)
   * @param {boolean} [options.rangeselect=false] - indicates the user has depressed the multiselect key (shift)
   */
		selectCard: function selectCard(cardId) {
			var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

			if (self.isStartingPointsDisplayed()) {
				//When starting points was selected, (or not multi-select - see below)
				//change displayed card (reaction will update selected card)
				self.exploreVM.setDisplayedToCard(cardId);
			} else if (options.multiselect) {
				//When multi-select, toggle selection of card - unless this would cause
				//no cards to be selected - in this case, do nothing
				if (!self.selection.isSelected(cardId) || self.selection.items.length !== 1) {
					self.selection.select(cardId, { control: options.multiselect });
				}
			} else if (options.rangeselect) {
				//When range select, update selection accordingly
				self.selection.select(cardId, { shift: options.rangeselect });
			} else {
				//When not multi-select, (or starting points was selected - see above)
				//change displayed card (reaction will update selected card)
				self.exploreVM.setDisplayedToCard(cardId);
			}
			self.restoreToolbarIfHidden();
		},
		selectAll: function selectAll() {
			self.selection.selectAll();
		},
		clearSelection: function clearSelection() {
			if (self.exploreVM.isStartingPointsDisplayed()) {
				self.selection.clear();
			} else {
				self.selection.select(self.exploreVM.getDisplayedCard());
			}
		},
		beginDrag: function beginDrag(ids) {
			self.isDragged = true;
			self.placeholders = ids;
		},

		/**
   * moves the place holder to the position of the passed card id, order/display is unchanged if the id is unknown or is part of the placeholder
   * @param {String} targetCardId id of the target card, new location of the ones in the placeholder
   */
		movePlaceHolderToCard: function movePlaceHolderToCard(targetCardId) {
			var ids = self.placeholders;
			var index = self.getItemIndex(targetCardId);

			if (index < 0) {
				return;
			}

			if (!ids.length) {
				return;
			}
			var firstPlaceHolderIndex = self.getItemIndex(ids[0]);

			if (firstPlaceHolderIndex < 0) {
				return;
			}

			if (ids.indexOf(targetCardId) < 0) {
				var displayedItems = buildNewDisplayedItems(self.items, ids, firstPlaceHolderIndex, targetCardId);
				setItems(self.items, displayedItems);
			}
		},
		endDrag: function endDrag() {
			self.isDragged = false;
			self.placeholders = [];

			var newItemsArray = self.items.map(function (id) {
				return self.layoutModel.findModel(id);
			});
			var payloadData = {
				undoRedoTransactionId: _underscore2.default.uniqueId('CardList')
			};
			self.layoutModel.replaceArray(newItemsArray, 'CardList', payloadData);
		},
		selectStartingPoints: function selectStartingPoints() {
			self.exploreVM.setDisplayedToStartingPoints();
			self.restoreToolbarIfHidden();
		},
		showContextMenu: function showContextMenu(ids) {
			self.contextMenu = ids;
		},
		clearContextMenu: function clearContextMenu() {
			self.contextMenu = null;
		},
		resetLoadingCards: function resetLoadingCards() {
			if (self._isAlive(self.exploreVM)) {
				self.exploreVM.resetThumbnailsQueue();
			}
		},
		resetCardNotification: function resetCardNotification() {
			self.exploreVM.notification.setListVisibility(false);
			self.exploreVM.notification.setActive(false);
		},
		loadCards: function loadCards(cardIds) {
			// only load cards that are not selected
			var nonSelectedCardIds = cardIds.filter(function (cardId) {
				return !self.isCardSelected(cardId);
			});
			self.exploreVM.thumbnails.queue(self.removePlaceholderCards(nonSelectedCardIds));
		},
		removePlaceholderCards: function removePlaceholderCards(cardIds) {
			var cards = cardIds.map(function (id) {
				return self.layoutModel.findModel(id);
			});
			var nonBlankCardIds = [];
			cards && cards.forEach(function (card) {
				var layout = card.cardModelUtil.getLayouts(card, card.boardModel);
				var hasWidget = layout.length > 0 && layout[0].hasOwnProperty('widgetLayout') || false;
				hasWidget && nonBlankCardIds.push(card.id);
			});
			return nonBlankCardIds;
		},

		/**
   * Restore toolbar if it is hidden
   */
		restoreToolbarIfHidden: function restoreToolbarIfHidden() {
			// collapses the filter dock if toolbar is hidden
			if (self.exploreVM.toolbar && self.exploreVM.toolbar.getIsHidden()) {
				self.layoutModel.getDashboardApi().triggerDashboardEvent('filterDock:collapse');
			}
		},


		/**
   * Synchronize thumbnails
   *
   * @param {string|string[]|Widget[]} widgets - widget(s) to synchronize
   *
   * @return {Promise} Promise to be resolved when the synchronize operations is completed
   */
		syncThumbnails: function syncThumbnails(widgets) {
			var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { idle: true };

			var getThumbnails = (0, _mobxStateTree.getEnv)(self).getThumbnails;
			if (!getThumbnails) {
				return Promise.resolve();
			}
			return getThumbnails(widgets, options).then(function (thumbnails) {
				self.thumbnails.addItems(thumbnails.map(function (_ref) {
					var data = _ref.data,
					    error = _ref.error,
					    warning = _ref.warning,
					    widgetId = _ref.widgetId,
					    type = _ref.type;

					return {
						widgetId: widgetId,
						type: type,
						data: data,
						error: error && error.message ? error : undefined,
						warning: warning && warning.message ? warning : undefined
					};
				}));
			});
		},


		/**
   * Synchronize initial thumbnails
   *
   * @return {Promise} Promise to be resolved when the synchronize operations is completed
   */
		syncInitialThumbnails: function syncInitialThumbnails() {
			return self.syncThumbnails(undefined, { idle: false });
		},


		/**
   * Check whether the card with a specific id contains a blank widget or not
   * @param {string} cardId - card id
   * @return {boolean} TRUE if the card contains a blank widget and FALSE if not
   */
		containsBlankWidget: function containsBlankWidget(cardId) {
			return self.exploreVM.containsBlankWidget(cardId);
		},
		isCardNew: function isCardNew(cardId) {
			return self.exploreVM.isCardNew(cardId);
		}
	};
});


function setItems(itemsArray, newValues) {
	(0, _ArrayOperations.replaceArray)(itemsArray, newValues);
}

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.Thumbnail = exports.ThumbnailWarning = exports.ThumbnailError = undefined;

var _mobxStateTree = __webpack_require__(7);

var ThumbnailError = exports.ThumbnailError = _mobxStateTree.types.model('ThumbnailError', {
	message: _mobxStateTree.types.string
}); /*
     *+------------------------------------------------------------------------+
     *| Licensed Materials - Property of IBM
     *| IBM Cognos Products: Explore
     *| (C) Copyright IBM Corp. 2018, 2019
     *|
     *| US Government Users Restricted Rights - Use, duplication or disclosure
     *| restricted by GSA ADP Schedule Contract with IBM Corp.
     *+------------------------------------------------------------------------+
     */
var ThumbnailWarning = exports.ThumbnailWarning = _mobxStateTree.types.model('ThumbnailWarning', {
	message: _mobxStateTree.types.string
});

var Thumbnail = exports.Thumbnail = _mobxStateTree.types.model('Thumbnail', {
	widgetId: _mobxStateTree.types.string,
	type: _mobxStateTree.types.optional(_mobxStateTree.types.string, ''),
	data: _mobxStateTree.types.optional(_mobxStateTree.types.string, ''),
	error: _mobxStateTree.types.union(ThumbnailError, _mobxStateTree.types.undefined),
	warning: _mobxStateTree.types.union(ThumbnailWarning, _mobxStateTree.types.undefined)
}).views(function (self) {
	return {
		hasError: function hasError() {
			return !!self.error;
		},
		hasWarning: function hasWarning() {
			return !!self.warning;
		}
	};
});

exports.default = _mobxStateTree.types.model('Thumbnails', {
	items: _mobxStateTree.types.optional(_mobxStateTree.types.array(Thumbnail), [])
}).views(function (self) {
	return {
		getItemByWidgetId: function getItemByWidgetId(id) {
			return self.items.find(function (item) {
				return item.widgetId === id;
			});
		},
		getItemIndexByWidgetId: function getItemIndexByWidgetId(id) {
			return self.items.findIndex(function (item) {
				return item.widgetId === id;
			});
		}
	};
}).actions(function (self) {

	var _addItem = function _addItem(item) {
		if (!item || !item.widgetId) {
			throw new Error('Invalid thumbnail item provided');
		}

		var index = self.getItemIndexByWidgetId(item.widgetId);
		if (index === -1) {
			self.items.push(item);
		} else {
			self.items.splice(index, 1, item);
		}
	};

	function setItems(items) {
		self.items = items;
	}

	/**
  * Add a single item
  *
  * @param {Thumbnail} item - single thumbnail model instance to add
  */
	function addItem(item) {
		_addItem(item);
	}

	/**
  * Add multiple items
  *
  * @param {Thumbnail[]} items - multiple thumbnail model instances to add
  */
	function addItems(items) {
		items.forEach(function (item) {
			return _addItem(item);
		});
	}

	return {
		setItems: setItems,
		addItem: addItem,
		addItems: addItems
	};
});

/***/ }),
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(162);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../node_modules/resolve-url-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./cardGridExtension.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../node_modules/resolve-url-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./cardGridExtension.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/*\n *+------------------------------------------------------------------------+\n *| Licensed Materials - Property of IBM\n *| IBM Cognos Products: Explore\n *| (C) Copyright IBM Corp. 2018\n *|\n *| US Government Users Restricted Rights - Use, duplication or disclosure\n *| restricted by GSA ADP Schedule Contract with IBM Corp.\n *+------------------------------------------------------------------------+\n */\n\n.explore-thumbnail-container {\n  height: 100%;\n}\n\n", ""]);

// exports


/***/ }),
/* 163 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_163__;

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018, 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
var BaseClass = __webpack_require__(165);

var RESIZABLE_HANDLE = 12;
var DEFAULT_WIDTH = 200 + RESIZABLE_HANDLE;
var MAX_WIDTH = 1000;

var CardGridSlideoutActionHandler = BaseClass.extend({

	getExtraCustomSpec: function getExtraCustomSpec(context) {
		var options = {
			id: 'dashboardPanel',
			reuseSlideout: true,
			width: DEFAULT_WIDTH + 'px',
			position: 'left',
			resizable: {
				min: DEFAULT_WIDTH,
				max: MAX_WIDTH
			},
			pinning: {
				isPinned: true,
				float: false,
				display: false
			},
			content: {
				module: 'explore/contrib/cards/extension',
				glassContext: context.glassContext
			}
		};
		return options;
	}
});

exports.default = CardGridSlideoutActionHandler;

/***/ }),
/* 165 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_165__;

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _PinsPanel = __webpack_require__(167);

var _PinsPanel2 = _interopRequireDefault(_PinsPanel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2018, 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
var BasePinView = __webpack_require__(169);


var PinView = BasePinView.extend({
  _getPinsPanelClass: function _getPinsPanelClass() {
    return _PinsPanel2.default;
  }
});

exports.default = PinView;

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2018, 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
var BasePinsPanel = __webpack_require__(168);

var PinsPanel = BasePinsPanel.extend({
	_addPinToLayout: function _addPinToLayout(_ref, isTouch) {
		var widgetFragment = _ref.model;
		var widgetLayout = widgetFragment.layout;


		var exploreCardFragment = void 0;
		if (widgetLayout.type === 'widget') {
			exploreCardFragment = _extends({}, widgetFragment, {
				layout: {
					id: 'cardId',
					relatedLayouts: '',
					type: 'exploreCard',
					items: [_extends({}, widgetLayout, {
						style: {}
					})]
				}
			});
		} else {
			exploreCardFragment = _extends({}, widgetFragment);
		}

		this.canvasController.addPin({
			model: exploreCardFragment
		}, isTouch);
	}
});

exports.default = PinsPanel;

/***/ }),
/* 168 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_168__;

/***/ }),
/* 169 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_169__;

/***/ })
],[120]);
});


// WEBPACK FOOTER //
// glass.min.js